<!--    To understand the functions behind the logic behind the Standard Offer and Quick Offer
Pls go to this
https://docs.google.com/spreadsheets/d/1sEKUk566G91flx14b3445wA8vJjgjjnvbWoW9SYLY3Y/edit#gid=0
https://docs.google.com/presentation/d/17QmUfYrz2xzHjfIYJcHFdnjE38pYYX0OHegTw5sLIc4/edit#slide=id.gea5e9d5157_0_5
https://docs.google.com/presentation/d/1hre87Fcm0EwYw1B3m9xMqW-SYOheDcJkZlcf9p0Y6lE/edit#slide=id.gee54f9e081_0_5
https://xd.adobe.com/view/fd98d8bc-e61f-4cb9-a76d-41887efb0919-a8cb/
https://xd.adobe.com/view/c64cd865-00ce-4cf2-a58c-f3845313a58b-931f/screen/e21b68a4-a223-478f-8594-646c7286c6e0/
-->
<template>
  <div id="alloffer" clas="mx4 my3 flex-column " >
      <div class="h2 my3 bold col-12 " v-if="offermakingtype === 'StandardTilbud'">Standard Tilbud</div>
      <div class="h2 my3 bold col-12 mx3 " v-else-if="offermakingtype === 'UploadTilbud'">Upload Tilbud</div>
      <div class="h2 my3 bold col-12 " v-else>HurtigtTilbud</div>
          <!-- <div class="white-background col-12 flex justify-center items-center" >
            <div  id="firststep" class=" col-4 activecustomerstep mr1 stephead lineshade mb2" ></div>
            <div  id="secondstep" class="col-4 stephead lineshade mb2 pr1" ></div>
            <div id="thirdstep" class="col-4 stephead lineshade ml1 mb2" ></div>
          </div> -->
        <div class="col-12" v-if="mainloading">
          <div class="loader"></div>
        </div>
        <b-form v-else>
        <p class="red warning h6 center" v-if="error.notask !== null">{{error.notask}}</p>
          <div class="clearfix white-background mx3">
            <div class="flex flex-column gibson">
              <div class="col-12 p0">
                <div v-if="currentstep === 1">
                <div class="mobile-flex-column flex flex-row col-12 sm-hide" v-if="offermakingtype === 'StandardTilbud'">
                  <div class="sm-col-12 lg-col-2 md-col-2 p0 mb1">
                    <button type="button" id="button1" ref="button1" @click="activebutton(1)" v-b-toggle.headertextimage class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 py2">Tilføj overskrift</span>
                      <span class=" m0 p0 flex items-center" >
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="sm-col-12 lg-col-2 md-col-2 p0 mrpointtwo mb1">
                    <button type="button" id="button2" ref="button2" @click="activebutton(2)" v-b-toggle.calculation class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 py2">Tilføj enhed</span>
                      <span class=" m0 p0 flex items-center" >
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="sm-col-12 lg-col-2 md-col-2 p0 mrpointtwo mb1">
                    <button type="button" id="button3" ref="button3" @click="activebutton(3)" v-b-toggle.rabat class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 py2">Tilføj rabat</span>
                      <span class=" m0 p0 flex items-center" >
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="sm-col-12 lg-col-2 md-col-2 p0 mrpointtwo mb1">
                    <button id="button4" ref="button4" @click="activebutton(4)" v-b-toggle.customer type="button" class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 p0 py2">Tilføj kunde</span>
                      <span class=" m0 p0 flex items-center" >
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="sm-col-12 lg-col-2 md-col-2 p0 mrpointtwo mb1">
                    <button id="button5" ref="button5" @click="activebutton(5)" v-b-toggle.betingelser type="button" class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 p0 py2">Tilføj betingelser</span>
                      <span class=" m0 p0 flex items-center" >
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="sm-col-12 lg-col-2 md-col-2 p0 mrpointtwo mb1">
                    <button id="button6" ref="button6"  @click="activebutton(6)" v-b-toggle.Anbefalinger type="button"  class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 p0 py2">Tilføj anbefaling</span>
                      <span class=" m0 p0 flex items-center" style="top:4px;">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>
                </div>
                <div class="flex flex-row col-12 p1 " v-else-if="offermakingtype === 'UploadTilbud'">
                  <div class="col-6 p0 m0 mrpointtwo">
                    <button type="button" id="button2" ref="button2" @click="activebutton(2)" v-b-toggle.calculation class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 py2">Tilføj enhed</span>
                      <span class=" m0 p0 flex items-center" >
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="col-6 p0 mrpointtwo">
                    <button id="button4" ref="button4" @click="activebutton(4)" v-b-toggle.customer type="button" class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 p0 py2">Tilføj kunde</span>
                      <span class=" m0 p0 flex items-center" >
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>
                </div>
                <div class="flex flex-row col-12 p0 " v-else>
                    <div class="col-6 p0 ">
                    <button type="button" id="button2" ref="button2" @click="activebutton(2)" v-b-toggle.calculation class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 py2">Tilføj enhed</span>
                      <span class=" m0 p0 flex items-center" >
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>
                    <div class="col-6 p0 mrpointtwo">
                      <button id="button4" ref="button4" @click="activebutton(4)" v-b-toggle.customer type="button" class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                        <span class="h6 m0 p0 py2">Tilføj kunde</span>
                        <span class=" m0 p0 flex items-center" >
                          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                        </span>
                      </button>
                    </div>
                </div>
                  <div class="sm-col-12 lg-col-2 md-col-2 p0 mb1 lg-hide md-hide" v-if="offermakingtype === 'StandardTilbud'">
                    <button type="button" id="button1" ref="mbutton1" @click="activebutton(1)" v-b-toggle.headertextimage class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 py2">Tilføj overskrift</span>
                      <span class=" m0 p0 flex items-center" >
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>
                  <!-- /* First button */-->
                  <b-collapse id="headertextimage" ref="button1collapse" class="col-12 pl2" >
                  <p class="h6 medium darkblue mt3">Overskriftstekst</p>
                      <b-form-input  placeholder="Din overskrift" v-model="form.headings" required @input="hidenamevalidator()" class="bg-light col-12 py1 mt1"></b-form-input>
                      <div class="red warning h6 col-12 px0" v-if="error.notask != '' && error.notask == 'Udfyld venligst din overskriftstekst for dit tilbud' ">
                          {{error.notask}}
                        </div>
                    <p class="h6 medium darkblue mt3">Overskriftsbillede</p>
                    <div class="flex flex-row col-12 flex-wrap">
                      <div class="m1" v-for="image in alliheadermages" :key="image.ImageId" @click="assignthisheaderimage(image.FileLocation)" >
                        <img class=" headerimage " :id="image.FileLocation.replaceAll('håndværker', 'haandvaerker')" @load="checkifthisisheaderimageactive(image.FileLocation.replaceAll('håndværker', 'haandvaerker'))" :src="image.FileLocation.replaceAll('/photos/', '')" v-if="image.FileLocation.includes('https://imagedelivery.net')">
                        <img class=" headerimage " :id="image.FileLocation.replaceAll('håndværker', 'haandvaerker')" @load="checkifthisisheaderimageactive(image.FileLocation.replaceAll('håndværker', 'haandvaerker'))" :src="image.FileLocation.replaceAll('håndværker', 'haandvaerker')" v-else>
                      </div>
                    </div>
                  </b-collapse>

                  <div class="sm-col-12 lg-col-2 md-col-2 p0  mb1 lg-hide md-hide" v-if="offermakingtype === 'StandardTilbud'">
                    <button type="button" id="button2" ref="mbutton2" @click="activebutton(2)" v-b-toggle.calculation class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 py2">Tilføj enhed</span>
                      <span class=" m0 p0 flex items-center" >
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>

                   <!-- /* Second button */-->
                    <b-collapse id="calculation" ref="button2collapse" class="col-12 pl2">
                        <div class=" flex flex-column" v-if="offermakingtype === 'UploadTilbud'">
                          <div>
                            <div class="flex justify-start items-center"><span>Pris</span><b-form-input type="number"  v-model="form.offeramount"   class="ml-auto pl1 col-1 bg-light pt1 my1"></b-form-input> kr</div>
                            <div class="my3 line-height-golden">
                                <div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">Enhedspris ekskl. Moms</p><p class="m0 p0 col-8 flex justify-end">{{parseInt(form.offeramount * form.quantity).toLocaleString('da-DK')}} kr</p></div>
                                <div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">25 % moms</p><p class="m0 p0 col-8 flex justify-end">25 %</p></div>
                                <div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">Enhedspris inkl. Moms</p><p class="m0 p0 col-8 flex justify-end">{{ computetaskprice().toLocaleString('da-DK') }} kr</p></div>
                            </div>
                            <div class="col-12">
                            <button  type="button" @click="addtask()" class="mrpointtwo right col-2 dark-button p2 h5 not-rounded gibson flex justify-center items-center" v-if="offermakingtype === 'UploadTilbud'">
                              <span class="">Tilføj enhed</span>
                            </button>
                          </div>
                            <div>
                              <span class="h4 mt3 center col col-12">Upload dit tilbud her <h6>kun en pdf-fil accepteres her</h6></span>
                              <b-form-group id="file" label="" label-for="fag" class="p0 form-group  form-group lg-col-12 md-col-12    ">
                                <file-upload-input-pdfonly token="" module="" @UpdateTilbudpdf="handleFileUploadpdf" class="education-upload"></file-upload-input-pdfonly>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                            <div class="col-12 m0 p0" v-if="offermakingtype !== 'StandardTilbud'">
                              <p class="h6 medium darkblue mt3 ">Overskriftstekst</p>
                              <b-form-input  placeholder="Din overskrift" v-model="form.headings" required  class="bg-light col-12 py1 mt1"></b-form-input>
                              <p class="h6 medium darkblue mt3">Overskriftsbillede</p>
                            </div>
                            <div class="col-12 pr0 pl0 ">
                            <b-form-textarea v-model="form.offerdescription"  rows="3" max-rows="3"
                                placeholder="Skriv tilbuddets indhold her.."  class="bg-light pt1 my2"></b-form-textarea>
                            </div>
                          <b-form-input type="number"  v-model="form.offeramount" placeholder="Pris" lang="dk"   class="bg-light pt1 my1"></b-form-input>
                          <div class="flex col-12 p0 m0">
                            <b-form-input  v-model="form.quantity" placeholder="Antal" class="bg-light pt1 my1 mr2 "></b-form-input>
                            <b-form-select v-model="form.quantityunit"  :options="optionsunitype" class="bg-light pt1 my1">
                            </b-form-select>
                          </div>
                          <div class="red warning h6 col-12 px0" v-if="error.notask != '' && error.notask == 'Tilføj din opgave med den tilsvarende pris' ">
                              {{error.notask}}
                            </div>
                          <button type="button" id="enhed" @click="addtask()" class=" ml-auto m0  addbuttonresponsive  dark-button p2 h5 my3 not-rounded gibson flex justify-center items-center" v-if="offermakingtype === 'StandardTilbud'">
                            <span class="">Tilføj enhed</span>
                          </button>
                          <div class="my2">
                              <div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">Enhedspris ekskl. Moms</p><p class="m0 p0 col-8 flex justify-end">{{parseInt(form.offeramount * form.quantity).toLocaleString('da-DK')}} kr</p></div>
                              <div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">25 % moms</p><p class="m0 p0 col-8 flex justify-end">25 %</p></div>
                              <div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">Enhedspris inkl. Moms</p><p class="m0 p0 col-8 flex justify-end">{{ computetaskprice().toLocaleString('da-DK') }} kr</p></div>
                          </div>
                      </div>
                    <div class="flex col-12 p0 m0 " v-if="offermakingtype !== 'StandardTilbud' ">
                      <button v-b-modal.conditionsstandard type="button" class=" col-6 dark-button p2 h5 not-rounded gibson flex justify-center items-center">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30" height="30"
                                  viewBox="1.5 0.5 524 618" enable-background="new 1.5 0.5 524 618" class="mr1" xml:space="preserve">
                                  <path fill="#fff" d="M485.328,3H150.641c-19.774,0-35.859,16.085-35.859,35.859v31.078H40.672
                                                c-19.774,0-35.859,16.085-35.859,35.859v404.721c0.009,0.01,0.019,0.019,0.028,0.023c0.005,3.101,1.191,6.149,3.474,8.428
                                                l92.524,92.529c2.288,2.288,5.346,3.502,8.456,3.502h0.014h266.05c19.774,0,35.859-16.085,35.859-35.859v-31.078h74.109
                                                c19.774,0,35.859-16.085,35.859-35.859V362.789c0-6.603-5.351-11.953-11.953-11.953s-11.953,5.351-11.953,11.953v149.414
                                                c0,6.593-5.36,11.953-11.953,11.953h-74.109v-69.165h35.309c6.602,0,11.953-5.355,11.953-11.953c0-6.602-5.352-11.953-11.953-11.953
                                                h-35.309v-43.021h35.309c6.602,0,11.953-5.351,11.953-11.953s-5.352-11.953-11.953-11.953h-35.309v-43.055h35.309
                                                c6.602,0,11.953-5.351,11.953-11.953c0-6.602-5.352-11.953-11.953-11.953h-35.309v-43.017h35.309
                                                c6.602,0,11.953-5.356,11.953-11.953c0-6.603-5.352-11.953-11.953-11.953h-35.309v-43.06h35.309c6.602,0,11.953-5.351,11.953-11.953
                                                c0-6.597-5.352-11.953-11.953-11.953h-35.309v-57.51c0-4.193-0.729-8.213-2.055-11.953h88.117v161.367
                                                c0,6.602,5.351,11.953,11.953,11.953s11.953-5.351,11.953-11.953V38.859C521.188,19.085,505.103,3,485.328,3z M97.342,574.191
                                                l-51.721-51.721h34.907c9.268,0,16.813,7.545,16.813,16.813V574.191z M387.313,579.141c0,6.593-5.36,11.953-11.953,11.953H121.248
                                                v-51.81c0-22.454-18.266-40.72-40.72-40.72h-51.81V160.781h358.594v14.47v0.014v0.009v66.938v0.014v0.009v66.904v0.015v0.009v66.938
                                                v0.015v0.009V579.141z M387.313,105.797v31.078H28.719v-31.078c0-6.593,5.36-11.953,11.953-11.953h334.688
                                                C381.952,93.844,387.313,99.204,387.313,105.797z M375.359,69.938H138.688V38.859c0-6.593,5.36-11.953,11.953-11.953h334.688
                                                c6.593,0,11.953,5.36,11.953,11.953v31.078H375.359z" />
                                  <path fill="#0590B9" d="M336.619,430.945H78.432c-6.602,0-11.953,5.351-11.953,11.953s5.351,11.953,11.953,11.953h258.188
                                                c6.603,0,11.953-5.351,11.953-11.953S343.222,430.945,336.619,430.945z" />
                                  <path fill="#0590B9"
                                    d="M336.619,497.873H216.383c-6.602,0-11.953,5.352-11.953,11.953c0,6.598,5.351,11.953,11.953,11.953h120.236
                                                c6.603,0,11.953-5.355,11.953-11.953C348.572,503.225,343.222,497.873,336.619,497.873z" />
                                  <path fill="#0590B9" d="M78.432,387.891h182.934c6.602,0,11.953-5.351,11.953-11.953s-5.351-11.953-11.953-11.953H78.432
                                                c-6.602,0-11.953,5.351-11.953,11.953S71.83,387.891,78.432,387.891z" />
                                  <path fill="#0590B9"
                                    d="M336.619,297.061H78.432c-6.602,0-11.953,5.351-11.953,11.953c0,6.598,5.351,11.953,11.953,11.953h258.188
                                                c6.603,0,11.953-5.355,11.953-11.953C348.572,302.412,343.222,297.061,336.619,297.061z" />
                                  <path fill="#0590B9" d="M78.432,254.001h90.27c6.602,0,11.953-5.351,11.953-11.953c0-6.597-5.351-11.953-11.953-11.953h-90.27
                                                c-6.602,0-11.953,5.356-11.953,11.953C66.479,248.651,71.83,254.001,78.432,254.001z" />
                                  <path fill="#0590B9"
                                    d="M336.619,230.095H230.437c-6.602,0-11.953,5.356-11.953,11.953c0,6.603,5.351,11.953,11.953,11.953h106.182
                                                c6.603,0,11.953-5.351,11.953-11.953C348.572,235.451,343.222,230.095,336.619,230.095z" />
                                  <path fill="#0590B9" d="M336.619,363.984h-19.592c-6.603,0-11.953,5.351-11.953,11.953s5.351,11.953,11.953,11.953h19.592
                                                c6.603,0,11.953-5.351,11.953-11.953S343.222,363.984,336.619,363.984z" />
                                  <path fill="#0590B9" d="M509.234,297.047c-3.143,0-6.229,1.279-8.451,3.502s-3.502,5.309-3.502,8.451s1.279,6.229,3.502,8.451
                                                s5.309,3.502,8.451,3.502s6.229-1.279,8.451-3.502s3.502-5.309,3.502-8.451s-1.279-6.229-3.502-8.451
                                                S512.377,297.047,509.234,297.047z" />
                                </svg>
                        Tilføj betingelser<i class="el-icon-search pl2 m0 h5"></i>
                      </button>
                      <button v-if="offermakingtype === 'HurtigtTilbud' " id="enhed" type="button" @click="addtask()" class="mrpointtwo  col-6 dark-button p2 h5 not-rounded gibson flex justify-center items-center">
                          <span class="">Tilføj enhed</span>
                      </button>
                      <button v-if="offermakingtype === 'UploadTilbud'" type="button"  @click="nextstebutton(), assigndatecomment()" class="mrpointtwo  col-6 dark-button p2 h5 not-rounded gibson flex justify-center items-center">
                          <span class="mx2 ">Fortsæt</span>
                          <span><i class="el-icon-right"></i></span>
                      </button>
                      <!--gemm for second/task/enhed button -->

                      </div>
                    <div class="col-12 m0 p1 flex flex-column more-muted-background my2  " v-if="rows.length > 0">
                      <p class="h6   m0">Opgave</p>
                          <div class="flex flex-column mb1" style="border-bottom: inset;" v-for="(datarow,index) in rows" :key="index">
                            <div class="flex col-12 h5 m0 p0 py1 line-height-golden" v-if="typeofclients === 'Minbolig2'"><p class="m0 semi-bold p0 ">{{datarow.custom_name}}</p> <i @click="deletetaskminbolig(datarow)" class="m0 red p0 ml-auto el-icon-delete-solid"></i></div>
                            <div class="flex col-12 h5 m0 p0 py1 line-height-golden" v-else><p class="m0 semi-bold p0 ">{{datarow.custom_name}}</p> <i @click="deletetask(datarow)" class="m0 red p0 ml-auto el-icon-delete-solid"></i></div>
                            <div class="h6 flex m0 p0 col-12 line-height-golden" ><p class="m0 p0 ">Pris</p><p class="m0 semi-bold p0 ml-auto">{{ (parseFloat(datarow.amount)).toLocaleString('da-DK') }} kr</p></div>

                            <div class="h6 flex m0 p0 col-12 line-height-golden" v-if="datarow.type === 0" ><p class="m0 p0 col-4">Antal</p><p class="m0 semi-bold p0 col-8 flex justify-end" >{{ (parseFloat(datarow.quantity)) }} Antal</p></div>
                            <div class="h6 flex m0 p0 col-12 line-height-golden" v-if="datarow.type === 1" ><p class="m0 p0 co l-4">Beløb</p><p class="m0 semi-bold p0 col-8 flex justify-end" >{{ (parseFloat(datarow.quantity)) }} kr</p></div>
                            <div class="h6 flex m0 p0 col-12 line-height-golden" v-if="datarow.type === 2"><p class="m0 p0 col-4">Timer</p><p class="m0 semi-bold p0 col-8 flex justify-end" >{{ (parseFloat(datarow.quantity)) }} Hr.</p></div>
                          </div> <!-- ((parseFloat(datarow.amount).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".").toString().replace('.', ',')) -->
                    </div>
                    <div class="more-muted-background col-12 p1 my2 py2" v-if="rows.length > 0">
                      <div class="h5 flex m0 line-height-golden"><p class="m0 p0 col-4">Subtotal</p><p class="m0 p0 col-8 flex justify-end">{{ (parseFloat(subtotalprice)).toLocaleString('da-DK') }} kr </p></div>
                      <div class="h5 flex m0 line-height-golden"><p class="m0 p0 col-4">MOMS</p><p class="m0 p0 col-8 flex justify-end">25 %</p></div>
                      <div class="h5 flex m0 line-height-golden" v-if="form.discount !== ''" ><p class="m0 p0 col-4">Rabat</p><p class="m0 p0 col-8 flex justify-end">{{ form.discount + ' ' + form.discountsymbol }}</p></div>
                      <div class="h5 flex m0 line-height-golden "><p class="m0 p0 col-4 sime-bold">I ALT</p><p class="m0 p0 col-8 flex justify-end">{{ (parseFloat(compututedtaxsingle)).toLocaleString('da-DK') }} kr </p></div>
                    </div>
                  </b-collapse>

                  <div class="sm-col-12 lg-col-2 md-col-2 p1 mb1 lg-hide md-hide" v-if="offermakingtype === 'StandardTilbud'">
                    <button type="button" id="button3" ref="mbutton3" @click="activebutton(3)" v-b-toggle.rabat class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                      <span class="h6 m0 py2">Tilføj rabat</span>
                      <span class=" m0 p0 flex items-center" >
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </button>
                  </div>

                  <!--  /* Third button */-->
                    <b-collapse id="rabat" ref="button3collapse" class="col-12 pl2 p0 my3">
                      <div class="flex col-12 p0 m0 justify-end ml-auto">
                      <!--gemm for third/rabbat button -->
                        <button type="button" @click="addiscount()" class=" m0 addbuttonresponsive dark-button p2 h5 not-rounded gibson flex justify-center items-center">
                            <span class="">Tilføj rabat</span>
                          </button>
                        </div>
                      <p class="h6 mt1">Rabat i kr</p>
                      <b-form-input type="number" id="discountamount" @change="disabletheother()" v-model="form.discountamount"   class="bg-light pt1 my1"></b-form-input>
                      <p class="h6 mt1">Rabat i procent</p>
                      <b-form-input type="number" id="discountpercentage" @change="disabletheother()" v-model="form.discountpercentage"   class="bg-light pt1 my1"></b-form-input>
                    </b-collapse>

                    <div class="sm-col-12 lg-col-2 md-col-2 p0 mb1 lg-hide md-hide"  v-if="offermakingtype === 'StandardTilbud'">
                      <button id="button4" ref="mbutton4" @click="activebutton(4)" v-b-toggle.customer type="button" class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                        <span class="h6 m0 p0 py2">Tilføj kunde</span>
                        <span class=" m0 p0 flex items-center" >
                          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                        </span>
                      </button>
                    </div>

                 <!--   /* Fourth button */-->
                    <b-collapse id="customer"  ref="button4collapse" class="col-12 pl2 p0">
                      <div class="flex flex-row justify-around col-12 mt2 mb3 mx0 p0">
                        <button type="button" id="startthis" @click="showcustomerselection()"  class="  lightblue-button col-6 pt1 pb1 pl1  ">Kunde<i class="el-icon-user-solid pl3 h4"></i></button>
                        <button type="button"  :disabled="customerInputDisabled" @click="hidecustomerselection(),resetcustomerdata()" class="    offer-form-white-button col-6 pt1 pb1 mrpointtwo">Ny Kontakt<i
                            class="el-icon-user pl3 h4"></i></button>
                      </div>
                        <div class="col-12" v-if="loading">
                          <div class="loader"></div>
                        </div>
                        <div v-else>
                          <div class="flex col-12 items-center m0 p0">
                          <p class="h6" id="customerstext" >Vælg en kunde</p>
                          <p class="h6 hide" id="newcustomersss">Indtast ny kunde</p>
                          <button type="button" id="newcustomers" @click="addCustomer()" class=" hide ml-auto m0 addbuttonresponsive dark-button p2 h4 not-rounded gibson flex justify-center items-center" v-if="offermakingtype === 'StandardTilbud' || offermakingtype === 'UploadTilbud'">
                                  <span class="">Tilføj ny Kunde</span>
                          </button>
                          </div>
                        <!-- eslint-disable -->
                        <b-form-select  id="customersselect"  v-model="customers" placeholder="Ingenting valgt" @change="assigncustomerinput(customers)" class="  col-12  darkblue semi-bold  not-rounded gibson mb1 mt1" style="height:48px;" :disabled="customerInputDisabledselect">
                          <template #first>
                            <b-form-select-option :value="null" disabled>Ingenting valgt</b-form-select-option>
                          </template>
                          <b-form-select-option v-for="(item,index) in items" :key="index" :value="item" >{{item.firstname + ' ' + item.lastname + ', ' + item.email + '-' + item.mobile}}</b-form-select-option>
                        </b-form-select>
                        <!-- eslint-enable -->
                          <b-form-input v-model="form.navm" placeholder="Navn"  required class="bg-light pt1  mb2 mt2" :disabled="customerInputDisabled"></b-form-input>
                          <b-form-input v-model="form.email"  placeholder="Email"   required class="bg-light pt1  mb2 mt2" :disabled="customerInputDisabled"></b-form-input>
                          <b-form-input v-model="form.mobile" placeholder="Mobil" required class="bg-light pt1  mb2 mt2" :disabled="customerInputDisabled"></b-form-input>
                          <form>
                          <b-form-input id="selectaddr" ref="selectaddr" list="addresslist"  v-model="seletectedaddress" placeholder="Skriv adresse" @keyup ="getaddressfromkeyword(seletectedaddress), assignaddresseinput(seletectedaddress)"  autocomplete="off"  class="  col-12  darkblue   not-rounded gibson pt1  mb2 mt2" :disabled="customerInputDisabled"></b-form-input>
                              <b-form-datalist id="addresslist" :options="searchgaddress"></b-form-datalist>
                        </form>
                            <div style="height:80px;" class="flex flex-row justify-center items-center" v-if="addressloading">
                              <i class="el-icon-loading"></i>
                            </div>
                            <div class=" red warning h6 col-12 px0" v-if="error.notask != '' && error.notask == 'Udfyld venligst dine kunders oplysninger' ">
                              {{error.notask}}
                            </div>
                            <div class="flex col-12 p0 m0 my3 gap2" v-if="offermakingtype !== 'StandardTilbud' && offermakingtype !== 'UploadTilbud'">
                              <button v-b-modal.conditionsstandard type="button"
                                  class= "mr-auto m0 col-6 dark-button p2 h5 not-rounded gibson flex justify-center items-center">
                                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30" height="30"
                                    viewBox="1.5 0.5 524 618" enable-background="new 1.5 0.5 524 618" class="mr1" xml:space="preserve">
                                    <path fill="#fff" d="M485.328,3H150.641c-19.774,0-35.859,16.085-35.859,35.859v31.078H40.672
                                                  c-19.774,0-35.859,16.085-35.859,35.859v404.721c0.009,0.01,0.019,0.019,0.028,0.023c0.005,3.101,1.191,6.149,3.474,8.428
                                                  l92.524,92.529c2.288,2.288,5.346,3.502,8.456,3.502h0.014h266.05c19.774,0,35.859-16.085,35.859-35.859v-31.078h74.109
                                                  c19.774,0,35.859-16.085,35.859-35.859V362.789c0-6.603-5.351-11.953-11.953-11.953s-11.953,5.351-11.953,11.953v149.414
                                                  c0,6.593-5.36,11.953-11.953,11.953h-74.109v-69.165h35.309c6.602,0,11.953-5.355,11.953-11.953c0-6.602-5.352-11.953-11.953-11.953
                                                  h-35.309v-43.021h35.309c6.602,0,11.953-5.351,11.953-11.953s-5.352-11.953-11.953-11.953h-35.309v-43.055h35.309
                                                  c6.602,0,11.953-5.351,11.953-11.953c0-6.602-5.352-11.953-11.953-11.953h-35.309v-43.017h35.309
                                                  c6.602,0,11.953-5.356,11.953-11.953c0-6.603-5.352-11.953-11.953-11.953h-35.309v-43.06h35.309c6.602,0,11.953-5.351,11.953-11.953
                                                  c0-6.597-5.352-11.953-11.953-11.953h-35.309v-57.51c0-4.193-0.729-8.213-2.055-11.953h88.117v161.367
                                                  c0,6.602,5.351,11.953,11.953,11.953s11.953-5.351,11.953-11.953V38.859C521.188,19.085,505.103,3,485.328,3z M97.342,574.191
                                                  l-51.721-51.721h34.907c9.268,0,16.813,7.545,16.813,16.813V574.191z M387.313,579.141c0,6.593-5.36,11.953-11.953,11.953H121.248
                                                  v-51.81c0-22.454-18.266-40.72-40.72-40.72h-51.81V160.781h358.594v14.47v0.014v0.009v66.938v0.014v0.009v66.904v0.015v0.009v66.938
                                                  v0.015v0.009V579.141z M387.313,105.797v31.078H28.719v-31.078c0-6.593,5.36-11.953,11.953-11.953h334.688
                                                  C381.952,93.844,387.313,99.204,387.313,105.797z M375.359,69.938H138.688V38.859c0-6.593,5.36-11.953,11.953-11.953h334.688
                                                  c6.593,0,11.953,5.36,11.953,11.953v31.078H375.359z" />
                                    <path fill="#0590B9" d="M336.619,430.945H78.432c-6.602,0-11.953,5.351-11.953,11.953s5.351,11.953,11.953,11.953h258.188
                                                  c6.603,0,11.953-5.351,11.953-11.953S343.222,430.945,336.619,430.945z" />
                                    <path fill="#0590B9"
                                      d="M336.619,497.873H216.383c-6.602,0-11.953,5.352-11.953,11.953c0,6.598,5.351,11.953,11.953,11.953h120.236
                                                  c6.603,0,11.953-5.355,11.953-11.953C348.572,503.225,343.222,497.873,336.619,497.873z" />
                                    <path fill="#0590B9" d="M78.432,387.891h182.934c6.602,0,11.953-5.351,11.953-11.953s-5.351-11.953-11.953-11.953H78.432
                                                  c-6.602,0-11.953,5.351-11.953,11.953S71.83,387.891,78.432,387.891z" />
                                    <path fill="#0590B9"
                                      d="M336.619,297.061H78.432c-6.602,0-11.953,5.351-11.953,11.953c0,6.598,5.351,11.953,11.953,11.953h258.188
                                                  c6.603,0,11.953-5.355,11.953-11.953C348.572,302.412,343.222,297.061,336.619,297.061z" />
                                    <path fill="#0590B9" d="M78.432,254.001h90.27c6.602,0,11.953-5.351,11.953-11.953c0-6.597-5.351-11.953-11.953-11.953h-90.27
                                                  c-6.602,0-11.953,5.356-11.953,11.953C66.479,248.651,71.83,254.001,78.432,254.001z" />
                                    <path fill="#0590B9"
                                      d="M336.619,230.095H230.437c-6.602,0-11.953,5.356-11.953,11.953c0,6.603,5.351,11.953,11.953,11.953h106.182
                                                  c6.603,0,11.953-5.351,11.953-11.953C348.572,235.451,343.222,230.095,336.619,230.095z" />
                                    <path fill="#0590B9" d="M336.619,363.984h-19.592c-6.603,0-11.953,5.351-11.953,11.953s5.351,11.953,11.953,11.953h19.592
                                                  c6.603,0,11.953-5.351,11.953-11.953S343.222,363.984,336.619,363.984z" />
                                    <path fill="#0590B9" d="M509.234,297.047c-3.143,0-6.229,1.279-8.451,3.502s-3.502,5.309-3.502,8.451s1.279,6.229,3.502,8.451
                                                  s5.309,3.502,8.451,3.502s6.229-1.279,8.451-3.502s3.502-5.309,3.502-8.451s-1.279-6.229-3.502-8.451
                                                  S512.377,297.047,509.234,297.047z" />
                                  </svg>
                                  Tilføj betingelser<i class="el-icon-search pl2 m0 h5"></i>
                              </button>
                              <button type="button" id="newcustomers" @click="addCustomer()" class=" hide ml-auto m0 col-6 dark-button p2 h4 not-rounded gibson flex justify-center items-center">
                                  <span class="">Tilføj ny Kunde</span>
                              </button>
                            </div>
                          <div class="flex items-center mobile-flex-column p0 col-12 justify-end" v-if="offermakingtype === 'StandardTilbud'"><p class="m0 h6 p0 flex mr-auto">Tilbuddet er gyldigt fra</p><datepicker id="datepickeroffer" v-model="form.dateoffer" :bootstrapStyling="false" placeholder="Dato" :language="da" class="ml-auto my1 sm-col-12 lg-cl-10 md-col-10"></datepicker><i class="ml-auto el-icon-date h5"></i></div>
                          <div class="flex items-center mobile-flex-column p0 col-12 justify-end" v-if="offermakingtype === 'StandardTilbud'"><p class="m0 h6 p0 flex mr-auto">Tilbuddet er gyldigt til</p><datepicker id="datepickeroffer2" v-model="form.dateofferexpiry" :bootstrapStyling="false" placeholder="Dato udløber" :language="da" class="ml-auto my1 sm-col-12 lg-cl-10 md-col-10"></datepicker><i class="ml-auto el-icon-date h5" ></i></div>
                          <b-form-input  v-model="form.comment"   placeholder="Kommentar" class="bg-light pt1 my1" v-if="offermakingtype === 'StandardTilbud'"></b-form-input>
                        </div>
                    </b-collapse>

                    <div class="sm-col-12 lg-col-2 md-col-2 p0 mb1 lg-hide md-hide" v-if="offermakingtype === 'StandardTilbud'">
                      <button id="button5" ref="mbutton5" @click="activebutton(5)" v-b-toggle.betingelser type="button" class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                        <span class="h6 m0 p0 py2">Tilføj betingelser</span>
                        <span class=" m0 p0 flex items-center" >
                          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                        </span>
                      </button>
                    </div>

                    <!-- /* Fifth button */ -->
                    <b-collapse id="betingelser"  ref="button5collapse" class="col-12 p0 pl2 mt2">
                      <div class="col-12" v-if="loading">
                          <div class="loader"></div>
                        </div>
                      <div class="col-12 p0" v-else>
                        <p class="h4 mt1 mb2 semi-bold">Betingelser og forbehold i tilbuddet</p>
                        <div class="white-background no-border col-12 p0 flex flex-row items-center " style="height:30px"><p class="semi-bold col-7 flex justify-start p0 m0">Brugerdefinerede Noter</p><i v-b-modal.addbrugerdefineredestandard class="col-5 flex justify-end el-icon-circle-plus-outline p0"></i></div>
                          <p class="m0" >Vælg her</p>
                        <!-- eslint-disable -->
                        <b-form-select   v-model="termsnotats"  placeholder="Ingenting valgt" @change="assigntermsinput('note' , termsnotats)" class="  col-12  darkblue semi-bold  not-rounded gibson mb1 mt1" style="height:48px;">
                          <b-form-select-option v-for="(item,index) in termsnotes" :key="index" :value="item" >{{item.title + '-' + item.description}}</b-form-select-option>
                        </b-form-select>
                        <!-- eslint-enable -->
                        <b-form-textarea  v-model="form.termsnote"  rows="4" max-rows="4" placeholder="Tilføj dine brugerdefinerede noter her"  class="bg-light pt1 mt1 ">
                        </b-form-textarea>
                        <div class="white-background no-border col-12 p0 flex flex-row items-center mt2 " style="height:30px"><p class="semi-bold col-7 flex justify-start p0 m0">Betingelser og standardforbehold</p><i v-b-modal.addbetingelserstandard class="col-5 flex justify-end el-icon-circle-plus-outline p0"></i></div>
                        <p class="m0">Vælg her</p>
                        <!-- eslint-disable -->
                        <b-form-select   v-model="termsbetings" placeholder="Ingenting valgt" @change="assigntermsinput('betingelser' , termsbetings)" class="  col-12  darkblue semi-bold  not-rounded gibson mb1 mt1" style="height:48px;">
                          <template #first>
                            <b-form-select-option :value="null" disabled>Ingenting valgt</b-form-select-option>
                          </template>
                          <b-form-select-option v-for="(item,index) in termsbetingelser" :key="index" :value="item" >{{item.title + '-' + item.description }}</b-form-select-option>
                        </b-form-select>
                        <!-- eslint-enable -->
                        <b-form-textarea  v-model="form.termsbetingelser"  rows="4" max-rows="4" placeholder="Tilføj dine brugerdefinerede noter her"  class="bg-light pt1 mt1 ">
                        </b-form-textarea>
                        <p class="mt2 semi-bold">Bilag</p>
                    </div>
                    <b-form-group id="file" label="" label-for="fag" class="p0 form-group  form-group lg-col-12 md-col-12    ">
                      <file-upload-input token="" module="" @UpdateTilbud="handleFileUpload" class="education-upload"></file-upload-input>
                    </b-form-group>
                    </b-collapse>

                    <div class="sm-col-12 lg-col-2 md-col-2 p0 mb1 lg-hide md-hide" v-if="offermakingtype === 'StandardTilbud'">
                      <button id="button6" ref="mbutton6"  @click="activebutton(6)" v-b-toggle.Anbefalinger type="button"  class=" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center">
                        <span class="h6 m0 p0 py2">Tilføj anbefaling</span>
                        <span class=" m0 p0 flex items-center" style="top:4px;">
                          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                        </span>
                      </button>
                    </div>

                    <!-- Sixth Button Recommendations -->
                    <b-collapse id="Anbefalinger"  ref="button6collapse" class="col-12 p0 pl2 mt2">
                      <p class="h5 medium darkblue mt3 mb2">Anbefalinger</p>
                        <div class="col-12" v-if="loading">
                          <div class="loader"></div>
                        </div>
                        <div class="flex col-12 p0 m0" v-else>
                        <div class="">
                        <p class="h6 ">Forøg din chance for at vinde buddet. Anbefalinger øger din troværdighed og skaber sikkerhed for nye kunder.</p>
                        <p class="h6 "> Vedhæft op til 5 anbefalinger fra din profil</p>
                        </div>
                        <div class="ml-auto">
                          <button  type="button" @click="confirmtilbud('finaloffer')" v-if="button >= 6 && this.editingdraft === 0" class=" h5 p2  gibson greenblue-button not-rounded flex justify-center items-center" >
                            <span class="mx2">Indsend</span>
                            <span><i class="el-icon-check"></i></span>
                          </button>
                          <button  type="button" @click="confirmtilbud('draftfinaloffer')" v-if="button >= 6 && this.editingdraft === 1" class="h5 p2  gibson greenblue-button not-rounded flex justify-center items-center" >
                            <span class="mx2">Indsend</span>
                            <span><i class="el-icon-check"></i></span>
                          </button>
                        <!-- <button type="button" @click="nextstebutton(), assigndatecomment()" class=" ml-auto  col-2 h4 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center" >
                          <span class="mx2 ">Fortsæt</span>
                          <span><i class="el-icon-right"></i></span>
                        </button> -->
                        </div>
                      </div>
                      <p class="col-12 h5 semi-bold line-height-golden my3">Udvalgte anbefalinger {{fiverecommendations.length}} / 5 </p>

                      <div class="col-12 mx0 px0 flex flex-wrap justify-around " >
                        <div class=" mx2 reviewsoffer  mb2   shadow p2" v-for="review in allrecommendatationsitems" :key="review.id" :id="'box' + review.ReviewId " >
                            <div class="flex justify-between items-center">
                              <div>
                          <div class="flex flex-column mt1" >
                                <image-rating v-model="review.Rating" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="22" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
                              </div>
                              <div>
                                <span v-if="review.AssignmentDistributedCount === 1" class="green">
                                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
                                </span>
                                <span v-else class="mediumgrey">
                                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="mb3">
                            <p class="h6 darkblue mb0 relative">{{ moment(review.RatedDate).format('ll') }}{{checkthebox(review.ReviewId)}}</p>
                          </div>
                          <div class="">
                              <el-collapse class="border-none">
                                <el-collapse-item title="Kommentar" :name="review.id">
                                  <p class="h6 gibson mediumgrey break-word">{{ review.RatingComment}}</p>
                                </el-collapse-item>
                              </el-collapse>

                          </div>
                          <div>
                            <p class="h5 darkblue semi-bold my2 line-height-golden">{{ review.RatedBy }}</p>
                          </div>
                          <div class="">
                            <div class="clearfix flex flex-column">

                            </div>
                            <div class="flex flex-row col-12">
                              <button  type="button" class="ml-auto p2 px2 gibson dark-button not-rounded flex justify-center items-center" @click="removethisrecommendation(review.ReviewId)" v-if="checkifselected(review.ReviewId)">
                              <i class="el-icon-minus"></i>
                              <span class="h6 mb0 left-align pl1">Fjern dette</span>
                            </button>
                            <button type="button" id="addthisreview" class="p2 px2 gibson dark-button not-rounded flex justify-center items-center" @click="assignfiverecommendations(review.ReviewId)" v-if="!checkifselected(review.ReviewId) && fiverecommendations.length <= 4">
                              <i class="el-icon-plus"></i>
                              <span class="h6 mb0 left-align pl1">Tilføj dette</span>
                            </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                </div>
                <div v-if="currentstep === 2">

                      <!-- <p class="h4 medium darkblue mt1 mb2">Anbefalinger</p>
                        <p class="h5 col-12">Forøg din chance for at vinde buddet. Anbefalinger øger din troværdighed og skaber sikkerhed for nye kunder.</p>
                        <p class="h5 col-12 "> Vedhæft op til 5 anbefalinger fra din profil</p>
                      <div class="flex col-12">
                      <button type="button" @click="backstep()" v-if="currentstep !== 1 " class="left  col-6 outlined-disabled-button p2 h4 not-rounded gibson flex justify-center items-center">
                          <span class="mx2 darkblue" ><i class="el-icon-back"></i></span>
                          <span class="darkblue">Tilbage</span>
                        </button>
                        <button type="button" @click="nextstep(), assigndatecomment()" v-if="currentstep !== 3" class="col-6 dark-button p2 h4 regular border-none not-rounded gibson flex justify-center items-center">
                          <span class="mx2">Fortsæt</span>
                          <span><i class="el-icon-right"></i></span>
                        </button>
                      </div>
                      <p class="col-12 h5 center semi-bold line-height-golden">Udvalgte anbefalinger {{fiverecommendations.length}} / 5 </p>
                      <div v-if="loading">
                          <div class="loader"></div>
                      </div>
                      <div class="col-12 mx0 px0 flex flex-wrap justify-center " >
                        <div class="col-3 reviewsoffer mx2 mb2   shadow p2" v-for="review in allrecommendatationsitems" :key="review.id" :id="review.ReviewId">
                          <div class="flex flex-column mt1">
                            <div class="flex justify-between items-center">
                              <div>
                                <image-rating v-model="review.Rating" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="22" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
                              </div>
                              <div>
                                <span v-if="review.AssignmentDistributedCount === 1" class="green">
                                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
                                </span>
                                <span v-else class="mediumgrey">
                                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="mb3">
                            <p class="h6 darkblue mb0 relative">{{ moment(review.RatedDate).format('ll') }}</p>
                          </div>
                          <div>
                            <p class="h5 darkblue semi-bold my2 line-height-golden">{{ review.RatedBy }}</p>
                          </div>
                          <div class="">
                            <div class="clearfix flex flex-column">

                            </div>
                            <div class="flex flex-row col-12">
                              <button  class="p2 px2 gibson dark-button not-rounded flex justify-center items-center" @click="removethisrecommendation(review.ReviewId)" v-if="checkifselected(review.ReviewId)">
                              <p class=""><i class="el-icon-minus"></i></p>
                              <span class="h6 mb0 left-align pl1">Fjern dette</span>
                            </button>
                            <button id="addthisreview" class="p2 px2 gibson dark-button not-rounded flex justify-center items-center" @click="assignfiverecommendations(review.ReviewId)" v-else>
                              <p class=""><i class="el-icon-plus"></i></p>
                              <span class="h6 mb0 left-align pl1">Tilføj dette</span>
                            </button>
                            </div>
                          </div>
                        </div>
                      </div> -->

                    </div>
                <div class="flex flex-column items-center justify-center mt2 mb2" v-if="currentstep === 3">
                  <div class="col-12" v-if="loading">
                    <div class="loader"></div>
                  </div>
                  <div>
                    <img src="static/img/customernoteicon.png" width="170" height="170" class="">
                    <p class="h6 medium darkblue mt3 mb3">Gennemgå dit tilbud ved at klikke på preview-knappen</p>
                    <button id="preview" type="button" @click="previewoffer()" class="dark-button p2 col-10 mb1 "><p class="h3">Forhåndsvisning</p></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="previewloading">
            <div class="loader"></div>
          </div>
          <div v-else>
            <div class="col-12 p0 pr3" v-if="offermakingtype === 'StandardTilbud'">
              <div class=" flex p0  my4 col-12 justify-between items-center white-background pt1">
                <!-- <button v-if="button > 1" type="button" @click="backstep()" class="left  col-2 dark-button p2 h4 not-rounded gibson flex justify-center items-center">
                  <span class="mx2 " ><i class="el-icon-back"></i></span>
                  <span class="">Tilbage</span>
                </button> -->
                <div id="specialrow" class="  ml3 flex justify-around border-1 mobile-flex-column " style="width: max(60%, 40rem,400px);" v-if="button > 4" >
                  <a @click="previewoffer()" class="col col-4 p1 m0 flex flex-column justify-center items-center mr1 more-muted-background"><i class="el-icon-copy-document m0 h3"></i><p class="h6 darkblue">Forhåndsvisning</p><a :href="pdfpdf" class="h6" v-if="pdfpdf !== null" style="font-size:.5em">download here</a></a>
                  <a class="col-4 p1 m0 flex flex-column justify-center items-center mr1 more-muted-background" v-b-modal.draftsstandard ><i class="el-icon-notebook-2 m0 h3"></i><p class="h6 nav-link m0 p0">Udkast</p></a>
                  <a v-if="editingdraft === 1" @click="updatetilbud()" class="col col-4 p1 m0 flex flex-column justify-center items-center more-muted-background mr1"><i class="el-icon-document-checked m0 h3"></i><p class="h6 darkblue m0">Opdater kladde</p></a>
                  <a v-else @click="saveasdraft()" class="md-col-4 lg-col-4 sm-col-6 p1 m0 flex flex-column justify-center items-center more-muted-background mr1"><i class="el-icon-document-checked m0 h3"></i><p class="h6 darkblue m0">Gem som kladde</p></a>
                </div>
                <button type="button" @click="nextstebutton(), assigndatecomment()" v-if="button <= 5 "  class=" ml-auto mx1 right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center" >
                  <span class="mx2 ">Fortsæt</span>
                  <span><i class="el-icon-right"></i></span>
                </button>
                <button  type="button" @click="confirmtilbud('finaloffer')" v-if="button >= 6 && this.editingdraft === 0" class="right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center" >
                  <span class="mx2">Indsend</span>
                  <span><i class="el-icon-check"></i></span>
                </button>
                <button  type="button" @click="confirmtilbud('draftfinaloffer')" v-if="button >= 6 && this.editingdraft === 1" class="right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center" >
                  <span class="mx2">Indsend</span>
                  <span><i class="el-icon-check"></i></span>
                </button>
                <!-- <button type="button" id="tilbudofferpreview" class="hide" v-confirm="{ ok: confirmmanswertilbud('final','yes'), cancel:confirmmanswertilbud('final','no'), message: 'Har du set forhåndsvisningen?', okText: 'Send tilbud til kundens email', cancelText: 'Annuller'}">offer</button> -->
                <!-- <button type="button" id="tilbudofferpreviewdraft" class="hide" v-confirm="{ ok: confirmmanswertilbud('final','yes'), cancel:confirmmanswertilbud('saveasdraft','no'), message: 'vil du ikke lave dette som et sidste tilbud eller gemme stadig som et udkast?', okText: 'Indsend', cancelText: 'Opdater kladde'}">offer</button> -->
              </div>
            </div>
            <div class="col-12 p0 pr3" v-else>
              <div class=" flex p0  my4 col-12 justify-between items-center white-background pt1">
                <!-- <button v-if="button > 1" type="button" @click="backstep()" class="left  col-2 dark-button p2 h4 not-rounded gibson flex justify-center items-center">
                  <span class="mx2 " ><i class="el-icon-back"></i></span>
                  <span class="">Tilbage</span>
                </button> -->
                <!-- (button > 2 && offermakingtype === 'UploadTilbud') -->
                <div v-if="offermakingtype === 'HurtigtTilbud'" id="specialrow" class="mobile-flex-column   ml3 flex justify-around border-1  " style="height:62px;width: max(60%, 40rem,400px);" >
                  <a @click="previewoffer()" class="col col-4 p1 m0 flex flex-column justify-center items-center mr1 more-muted-background"><i class="el-icon-copy-document m0 h3"></i><p class="h6 darkblue">Forhåndsvisning</p><a :href="pdfpdf" class="h6" v-if="pdfpdf !== null" style="font-size:.5em">download here</a></a>
                  <a class="col-4 p1 m0 flex flex-column justify-center items-center mr1 more-muted-background" v-b-modal.draftsstandard ><i class="el-icon-notebook-2 m0 h3"></i><p class="h6 nav-link m0 p0">Udkast</p></a>
                  <a v-if="editingdraft === 1" @click="updatetilbud()" class="col col-4 p1 m0 flex flex-column justify-center items-center more-muted-background mr1"><i class="el-icon-document-checked m0 h3"></i><p class="h6 darkblue m0">Opdater kladde</p></a>
                  <a v-else @click="saveasdraft()" class="col md-col-4 lg-col-4 sm-col-6 p1 m0 flex flex-column justify-center items-center more-muted-background mr1"><i class="el-icon-document-checked m0 h3"></i><p class="h6 darkblue m0">Gem som kladde</p></a>
                </div>
                <button type="button" @click="nextstebutton(), assigndatecomment()" v-if="button <= 2 && offermakingtype !== 'UploadTilbud'"  class=" ml-auto right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center" >
                  <span class="mx2 ">Fortsæt</span>
                  <span><i class="el-icon-right"></i></span>
                </button>
                <button  type="button" @click="confirmtilbud('finaloffer')" v-if="(button >= 4 && editingdraft === 0)" class="ml-auto right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center" >
                  <span class="mx2">Indsend</span>
                  <span><i class="el-icon-check"></i  ></span>
                </button>
                <button  type="button" @click="confirmtilbud('draftfinaloffer')" v-if="button >= 4 && editingdraft === 1" class="right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center" >
                  <span class="mx2">Indsend</span>
                  <span><i class="el-icon-check"></i></span>
                </button>
                <!-- <button type="button" id="tilbudofferpreview" class="hide" v-confirm="{ ok: confirmmanswertilbud('final','yes'), cancel:confirmmanswertilbud('final','no'), message: 'Har du set forhåndsvisningen?', okText: 'Send tilbud til kundens email', cancelText: 'Annuller'}">offer</button>
                <button type="button" id="tilbudofferpreviewdraft" class="hide" v-confirm="{ ok: confirmmanswertilbud('final','yes'), cancel:confirmmanswertilbud('saveasdraft','no'), message: 'vil du ikke lave dette som et sidste tilbud eller gemme stadig som et udkast?', okText: 'Indsend', cancelText: 'Opdater kladde'}">offer</button> -->
              </div>
            </div>

          </div>
          </b-form>
          <div style="height:200px;"></div>

  <b-modal  centered hide-footer @show="showbilag" id="conditionsstandard" ref="quickofferconditions">
            <slot name="modal-header">
          <div class="col-12 flex justify-start items-center white-background  px0 mx0">
            <button type="button" @click="hideModalconditions() " class="white-button no-border not-rounded gibson ">
              <span>
              <i class="pt2 el-icon-back"></i>
              </span>
            </button>
          </div>
        </slot>

        <div class="clearfix white-background pr2 pl2">
          <div class="flex flex-column gibson">
            <p class="h3 my1 semi-bold pl2" >Tilføj betingelser</p>
            <p class="h4 mt1 mb2 semi-bold pl2">Betingelser og forbehold i tilbuddet</p>
            <div class="col-12 ">
              <div class="white-background no-border col-12 p0 flex flex-row items-center " style="height:30px"><p class="semi-bold col-7 flex justify-start p0 m0">Brugerdefinerede Noter</p><i v-b-modal.addbrugerdefineredestandard class="col-5 flex justify-end el-icon-circle-plus-outline p0"></i></div>
                <p class="m0" >Vælg her</p>
                <!-- eslint-disable -->
                <template>
                <b-form-select   v-model="termsnotats"  placeholder="Ingenting valgt" @change="assigntermsinput('note' , termsnotats)" class="  col-12  darkblue semi-bold  not-rounded gibson mb1 mt1" style="height:48px;">
                  <b-form-select-option  class="col-6" v-for="(item,index) in termsnotes" :key="index" :value="item" >{{item.title + '-' + item.description.substring(0,30)}}</b-form-select-option>
                </b-form-select>
                </template>
                <!-- eslint-enable -->
                <b-form-textarea  v-model="form.termsnote"  rows="4" max-rows="4" placeholder="Tilføj dine brugerdefinerede noter her"  class="bg-light pt1 mt1 ">
                </b-form-textarea>

                <div class="white-background no-border col-12 p0 flex flex-row items-center mt2 " style="height:30px"><p class="semi-bold col-7 flex justify-start p0 m0">Betingelser og standardforbehold</p><i v-b-modal.addbetingelserstandard class="col-5 flex justify-end el-icon-circle-plus-outline p0"></i></div>
                <p class="m0">Vælg her</p>
                <!-- eslint-disable -->
                <b-form-select   v-model="termsbetings" placeholder="Ingenting valgt" @change="assigntermsinput('betingelser' , termsbetings)" class="  col-12  darkblue semi-bold  not-rounded gibson mb1 mt1" style="height:48px;">
                  <template #first>
                    <b-form-select-option :value="null" disabled>Ingenting valgt</b-form-select-option>
                  </template>
                  <b-form-select-option v-for="(item,index) in termsbetingelser" :key="index" :value="item" >{{item.title + '-' + item.description.substring(0,30) }}</b-form-select-option>
                </b-form-select>
                <!-- eslint-enable -->
                <b-form-textarea  v-model="form.termsbetingelser"  rows="4" max-rows="4" placeholder="Tilføj dine brugerdefinerede noter her"  class="bg-light pt1 mt1 ">
                </b-form-textarea>
                <p class="mt2 semi-bold">Bilag</p>
            </div>
          </div>
          <b-form-group id="file" label="" label-for="fag" class="p0 form-group  form-group lg-col-12 md-col-12    ">
            <file-upload-input token="" module="" @UpdateTilbud="handleFileUpload" class="education-upload"></file-upload-input>
          </b-form-group>
          <p id="bilagfilestext" clss="h6 hide">Dine filer</p>
          <div id="bilagfiles" class="flex flex-column item-start col-12 hide ">
            <div class="" v-for="(item,index) in form.bilagfile" :key="index">
            <span class="h6 gibson regular darkblue line-height-1 mr3" style="word-break: break-word;">{{item}}</span>
            <button class="not-rounded delete-button p1 border-none" @click="removeitembilag(item)">
              <span>
                <i class="el-icon-delete"></i>
              </span>
            </button>
            </div>
          </div>
        </div>

      <div slot="modal-footer" class="col-12 p2 white-background" ></div>
  </b-modal>
  <b-modal  centered hide-footer  id="draftsstandard" ref="quickofferdraft">
          <slot name="modal-header">
            <div class="col-12 flex justify-start items-center white-background  px0 mx0">
              <button type="button" @click="hideModaldrafts" class="white-button no-border not-rounded gibson ">
                <span>
                <i class="pt2 el-icon-back"></i>
                </span>
              </button>
            </div>
          </slot>

          <div class="clearfix white-background pr2 pl2">
            <div class="flex flex-column gibson">
              <p class="h5 my1 semi-bold" >Tilbuds kladder</p>
              <p class="h6 my2 " >Når du genoptager et tilbud, sletters det fra kladdelisten. Vælg et kladde, du vil fortsætte:</p>
              <div class="col-12 flex flex-column containerdrafts">
                <div class=" flex flex-column  col-12 m0 p1 more-muted-background mb2 p1 "  v-b-modal.drafteeditordeletestandard  v-for="(item,index) in draftitems" :key="index" @click="fordeletecontinue(item)">

                    <div class="flex flex-row"><p class="ml1 m0 h5 semi-bold ">{{item.firstname + ' ' + item.lastname }}</p></div>
                    <div class="flex flex-row"><i class="el-icon-star-off"></i><p class="ml2 m0">{{item.info.reference_number }}</p></div>
                    <div class="flex flex-row"><i class="el-icon-date"></i><p class="ml2 m0">{{item.createdtime}}</p></div>
                    <!-- <a @click=" deletedrafttilbud(item)">delete</a> -->
                </div>
              </div>
            </div>
          </div>

          <div slot="modal-footer" class="col-12 p2 white-background" ><p>_</p>
          </div>
  </b-modal>
  <b-modal  centered hide-footer  id="drafteeditordeletestandard" ref="drafteeditordeletemodal">
    <slot name="modal-header">
            <div class="col-12 flex justify-start items-center white-background  px0 mx0">
              <button type="button" @click="hidemodaldrafteeditordelete" class="white-button no-border not-rounded gibson ">
                <span>
                <i class="pt2 el-icon-back"></i>
                </span>
              </button>
            </div>
          </slot>
          <form>
          <div class="clearfix white-background pr2 pl2">
            <div class="flex flex-column items-center gibson">
              <p class="h5 my1 semi-bold" >Vælg venligst</p>
              <div class="col-12" v-if="loading">
                <div class="loader"></div>
              </div>
              <div class="flex justify-between col-10"  v-else>
              <button  type="button" @click="continueeditdrafttilbud(fordelete)" class="mr1 col-6 dark-button p2 h4 regular border-none not-rounded gibson flex justify-center items-center">
                <span class="mx2">Redigere</span>
                <span><i class="el-icon-right"></i></span>
              </button>
              <button type="button"  @click="deletedrafttilbud(fordelete)" class="col-6 dark-button p2 h4 regular border-none not-rounded gibson flex justify-center items-center">
                <span class="mx2">Slet</span>
                <span><i class="el-icon-delete"></i></span>
              </button>
              </div>
            </div>
          </div>
      </form>
          <div slot="modal-footer" class="col-12 p2 white-background" ><p>_</p>
          </div>
  </b-modal>
  <b-modal  centered hide-footer  id="addbrugerdefineredestandard" ref="addbrugerdefinerede">
          <slot name="modal-header">
            <div class="col-12 flex justify-start items-center white-background  px0 mx0">
              <button type="button" @click="hideModaladdbrugerdefinerede" class="pl3 white-button no-border not-rounded gibson ">
                <span>
                <i class="pt2 el-icon-back"></i>
                </span>
              </button>
            </div>
          </slot>
        <form>
          <div class="clearfix white-background pr2 pl2">
            <div class="flex flex-column gibson">
              <p class="h4 mt1 mb2 center semi-bold">Brugerdefinerede noter</p>
              <div class="col-12 ">
                <b-form-input v-model="form.termsaddnotetitle" placeholder="Title"  required class="bg-light pt1  mb2 mt2"></b-form-input>
                <b-form-textarea  v-model="form.termsaddnotedesc" rows="7" max-rows="7" placeholder="Tilføj dine vilkå og betingelser her"  class="bg-light pt1 mt1 ">
                </b-form-textarea>
              </div>
            </div>
          </div>
          <div slot="modal-footer" class="col-12 p2 white-background" >
            <button  type="button" @click="addterms('note')"  class=" ml2 col-6 dark-button p2 h4 regular border-none not-rounded gibson ">
                  <span class="mx2">Gem</span>
            </button>
          </div>
    </form>
  </b-modal>
  <b-modal  centered hide-footer  id="addbetingelserstandard" ref="addbetingelser">
          <slot name="modal-header">
            <div class="col-12 flex justify-start items-center white-background  px0 mx0">
              <button type="button" @click="hideModaladdbetingelser" class="pl3 white-button no-border not-rounded gibson ">
                <span>
                <i class="pt2 el-icon-back"></i>
                </span>
              </button>
            </div>
          </slot>
          <form>
          <div class="clearfix white-background pr2 pl2">
            <div class="flex flex-column gibson">
              <p class="h4 mt1 mb2 center semi-bold">Betingelser og standardforbehold</p>
              <div class="col-12 ">
                <b-form-input v-model="form.termsbetingelsertitle" placeholder="Title"  required class="bg-light pt1  mb2 mt2"></b-form-input>
                <b-form-textarea v-model="form.termsbetingelserdesc" required rows="7" max-rows="7" placeholder="Tilføj dine vilkå og betingelser her"  class="bg-light pt1 mt1 ">
                </b-form-textarea>
              </div>
            </div>
          </div>
          <div slot="modal-footer" class="col-12 p2 white-background" >
            <button type="button"  @click="addterms('betingelser')"  class=" ml2 col-6 dark-button p2 h4 regular border-none not-rounded gibson ">
                  <span class="mx2">Gem</span>
            </button>
          </div>
      </form>
  </b-modal>
  <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  <noneligibleFeaturepop ref="noneligibleFeaturepop"></noneligibleFeaturepop>
  </div>
</template>
<script>
import noneligibleFeaturepop from './noneligibleFeaturepop'
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import uuid from 'uuid/v4'
import fileUploadInput from '../../components/file-upload-input'
import fileUploadInputpdfonly from '../../components/file-upload-input-pdfonly'
import {ImageRating} from 'vue-rate-it'
import reviews from './Reviews'
import datepicker from 'vuejs-datepicker'
import {en, da} from 'vuejs-datepicker/dist/locale'
import FileUploadInputPdfonly from '../../components/file-upload-input-pdfonly.vue'
// import projectimages from '../../'
export default {
  name: 'tilbudpage',
  components: {
    loading,
    Simplert,
    uuid,
    reviews,
    ImageRating,
    fileUploadInput,
    datepicker,
    fileUploadInputpdfonly,
    en,
    da,
    FileUploadInputPdfonly,
    noneligibleFeaturepop
    // projectimages
  },
  data () {
    return {
      da: da,
      onlyfile: false,
      offermakingtype: '',
      compututedtaxsingle: '',
      subtotalprice: '',
      totalstep: 3,
      salesPerson: localStorage.getItem('id_token_portal'),
      salesPersonNew: localStorage.getItem('id_token_portalbitrix'),
      haaid: localStorage.getItem('haaid'),
      appid: '',
      customerpartnerid: 0,
      headertext: '',
      header_image: '',
      currentstep: 1,
      button: 1,
      savedraft: 0,
      usereferencenumber: 0,
      editingdraft: 0,
      pdfurl: null,
      pdfpdf: null,
      uploadedpdf: '',
      newfiles: [],
      fordelete: [],
      seletectedaddress: '',
      customers: null,
      termsnotats: [],
      termsbetings: [],
      termsbetingelser: [],
      termsnotes: [],
      loading: false,
      previewloading: false,
      addressloading: false,
      searchgaddress: [],
      items: [],
      alltilbud: [],
      alltilbudanduserinfo: [],
      alliheadermages: [],
      draftitems: [],
      itsok: true,
      mainfiles: [],
      mainloading: false,
      fiverecommendations: [],
      allrecommendatationsitems: [],
      optionsunitype: [
        { value: 0, text: 'Antal' },
        { value: 1, text: 'Beløb' },
        { value: 2, text: 'Timer' }
      ],
      rows: [],
      row: {
        uuid: '',
        name: '',
        selected_item: null,
        show_custom_item: false,
        custom_name: '',
        quantity: 1,
        unitPrice: 0,
        discount: 0,
        tax: 0,
        type: 1,
        amount: 0,
        description: ''
      },
      info: {
        id: null,
        currency_id: null,
        customer_id: null,
        customer_note: null,
        date: this.currentandexpiryDateTime(),
        expiry_date: this.currentandexpiryDateTime('expiry'),
        expiry_date_detail: '',
        upload_token: '',
        itme_type: '',
        rows: [],
        subject: '',
        description: '',
        subtotal: 0,
        subtotalDiscount: 0,
        line_item_discount_type: true,
        subtotalDiscount_type: false,
        subtotalTax: 25,
        subtotal_tax: null,
        subtotalShippingAndHandling: 0,
        total: 0,
        reference_number: '',
        quotation_number: '',
        quotation_prefix: '',
        is_draft: 0,
        show_sub_total_tax: true,
        show_sub_total_discount: true,
        show_sub_total_shipping_and_handling: true,
        show_line_item_tax: true,
        show_line_item_discount: true,
        show_line_item_description: true,
        memo: '',
        tnc: ''
      },
      tilbud: {
        onlyfile: false,
        appid: null,
        betingelser: null,
        bilag: null,
        bilagfile: null,
        cid: '',
        condition: null,
        createdtime: null,
        deleted: null,
        files: [],
        firstname: null,
        header_image: null,
        header_text: null,
        id: null,
        image: null,
        imgfile: null,
        info: [],
        is_darft: null,
        lastname: null,
        mobile: null,
        name: null,
        notat: null,
        offerfile: null,
        pid: null,
        recommendations: null,
        reference_number: null,
        sent: null
      },
      mainTilbud: {
        app: null,
        customer: null,
        partner: [],
        partnerid: '',
        tilbud: []
      },
      form: {
        headings: null,
        offerdescription: null,
        offeramount: null,
        quantity: 1,
        quantityunit: 0,
        discount: '',
        discountsymbol: '',
        navm: null,
        adresse: null,
        adresseid: '',
        adresseadgang: '',
        email: null,
        mobile: null,
        dateoffer: this.currentandexpiryDateTime(),
        dateofferexpiry: this.currentandexpiryDateTime('expiry'),
        comment: '',
        discountamount: 0,
        discountpercentage: 0,
        termsnote: null,
        termsaddnotetitle: '',
        termsaddnotedesc: '',
        termsaddnotetype: 'note',
        termsbetingelser: null,
        termsbetingelsertitle: '',
        termsbetingelserdesc: '',
        termsbetingelsertype: 'betingelser',
        bilagfile: [],
        headerImage: ''
      },
      error: {
        notask: ''
      },
      rowbolig: {
        title: '',
        description: '',
        unit: '',
        value: '',
        quantity: ''
      },
      rowsbolig: [],
      selectedProjectData: {},
      customerInputDisabled: false,
      customerInputDisabledselect: false,
      kunderid: '',
      eligible: '',
      subtotalprices: '',
      typeofclients: '',
      addresses: {}
    }
  },
  created () {
    this.eligible = localStorage.getItem('OfferCreator')
    this.kunderid = this.$route.query.app
    if (this.eligible) {
      this.reloadthepage()
      this.getaddressfromkeyword('s')
      this.getallofferbypartner()
      this.currentandexpiryDateTime()
      this.getallactivecustomerandofferbypartner()
      this.getterms()
      this.getallrecommendations()
      this.getallheaderimage()
      if (this.$route.query.projectId) {
        this.typeofclients = 'Minbolig2'
        this.getSelectedProj()
      }
    }
  },
  watch: {
    $route () {
      this.offermakingtype = this.$route.name
      this.initialstep()
    },
    'form.offeramount' (val) {
      if (val) this.form.offeramount = val.replace('.', '')
    },
    'form.discountamount' (val) {
      if (val) this.form.discountamount = val.replace('.', '')
    },
    'form.discountpercentage' (val) {
      if (val) this.form.discountpercentage = val.replace('.', '')
    }
  },
  computed: {
    // answers () {
    //   return Object.entries(this.form).map(([key, value]) => ({ [key]: value }))
    // }
  },
  mounted () {
    this.initialstep()
    this.getdataigibility()
    if (this.$route.query.name) {
      this.checkCustomer()
    }
  },
  methods: {
    getdataigibility () {
      setTimeout(() => {
        this.eligible = localStorage.getItem('OfferCreator')
        if (this.eligible === 'false') {
          this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '/newsfeed', 'OfferCreator')
        }
      }, 3000)
    },
    checkCustomer () {
      var name = this.$route.query.name
      if (name !== null || name !== '') {
        var email = this.$route.query.email
        var mobile = this.$route.query.mobile
        var address = this.$route.query.address

        this.form.navm = name
        this.form.email = email
        this.form.mobile = mobile
        this.form.adresse = address
        this.seletectedaddress = address
        this.customerInputDisabled = true
        this.customerInputDisabledselect = true
      }
    },
    reloadthepage () {
      this.offermakingtype = this.$route.name
    },
    focusthis () {
      // this.$refs.selectaddr.focus()
    },
    hideModalquickandstandard () {
      this.$refs['quickandstandard'].hide()
    },
    hideModal () {
      this.$refs['quickoffermodal'].hide()
    },
    hideModalconditions () {
      this.$refs['quickofferconditions'].hide()
    },
    hideModaladdbrugerdefinerede () {
      this.$refs['addbrugerdefinerede'].hide()
    },
    hideModaladdbetingelser () {
      this.$refs['addbetingelser'].hide()
    },
    hideModaldrafts () {
      this.$refs['quickofferdraft'].hide()
    },
    hidemodaldrafteeditordelete () {
      this.$refs['drafteeditordeletemodal'].hide()
    },
    initialstep () {
      if (this.offermakingtype === 'StandardTilbud') {
        this.$refs.button2collapse.show = false
        // this.$refs.button2collapse.show = false
        this.$refs.button1collapse.show = true
        // this.$refs.button1.classList.remove('buttonstep')
        this.activebutton(1)
      }
      if (this.offermakingtype === 'HurtigtTilbud') {
        this.$refs.button2collapse.show = true
        // this.$refs.button1collapse.show = false
        // this.$refs.button2.classList.remove('buttonstep')
        this.activebutton(2)
        // this.$refs.button4.classList.add('buttonstep')
      }
      if (this.offermakingtype === 'UploadTilbud') {
        this.$refs.button2collapse.show = true
        this.activebutton(2)
      }
    },
    nextstep () {
      if (this.currentstep === 1) {
        if (this.form.headings === null) {
          return false
        } else if (this.rows.length === 0 || this.rows === null || this.rows === undefined) {
          this.error.notask = 'Tilføj din opgave ved at trykke på Tilføj enhed '
          return false
        } else {
          this.currentstep++
          this.error.notask = ''
          document.querySelector('div#firststep').classList.remove('activecustomerstep')
          return
        }
      }
      this.currentstep++
      if (this.currentstep === 2) {
        document.querySelector('div#firststep').classList.remove('activecustomerstep')
        document.querySelector('div#secondstep').classList.add('activecustomerstep')
        if (this.form.navm === null) { this.getallactivecustomerandofferbypartner() }
        if (this.form.navm === null || this.seletectedaddress === null || this.form.email === null || this.form.mobile === null) {
          return false
        }
        this.error.notask = ''
      }
      if (this.currentstep === 3) {
        document.querySelector('div#secondstep').classList.remove('activecustomerstep')
        document.querySelector('div#thirdstep').classList.add('activecustomerstep')
        this.currentstep = 3
      }
    },
    nextstebutton () {
      if (this.offermakingtype === 'StandardTilbud') {
        this.button++
        document.getElementById('button' + this.button).click()
      } else {
        this.button = 4
        document.getElementById('button' + this.button).click()
      }
    },
    backstep () {
      if (this.currentstep === 3) {
        document.querySelector('div#secondstep').classList.add('activecustomerstep')
        document.querySelector('div#thirdstep').classList.remove('activecustomerstep')
      }
      if (this.currentstep === 2) {
        document.querySelector('div#secondstep').classList.remove('activecustomerstep')
        document.querySelector('div#firststep').classList.add('activecustomerstep')
      }
      this.currentstep--
    },
    activebutton (a) {
      this.button = a
      if (this.offermakingtype === 'StandardTilbud') {
        if (a === 1) {
          this.$refs.button1.classList.remove('buttonstep')
          this.$refs.mbutton1.classList.remove('buttonstep')
          this.$refs.button2.classList.add('buttonstep')
          this.$refs.button3.classList.add('buttonstep')
          this.$refs.button4.classList.add('buttonstep')
          this.$refs.button5.classList.add('buttonstep')
          this.$refs.button6.classList.add('buttonstep')
          this.$refs.mbutton2.classList.add('buttonstep')
          this.$refs.mbutton3.classList.add('buttonstep')
          this.$refs.mbutton4.classList.add('buttonstep')
          this.$refs.mbutton5.classList.add('buttonstep')
          this.$refs.mbutton6.classList.add('buttonstep')
          this.$refs.button2collapse.show = false
          this.$refs.button3collapse.show = false
          this.$refs.button4collapse.show = false
          this.$refs.button5collapse.show = false
          this.$refs.button6collapse.show = false
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep')
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep')
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep')
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep')
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep')
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep')
          }
        }
        if (a === 2) {
          this.$refs.button2.classList.remove('buttonstep')
          this.$refs.mbutton2.classList.remove('buttonstep')
          this.$refs.button1.classList.add('buttonstep')
          this.$refs.button3.classList.add('buttonstep')
          this.$refs.button4.classList.add('buttonstep')
          this.$refs.button5.classList.add('buttonstep')
          this.$refs.button6.classList.add('buttonstep')
          this.$refs.mbutton1.classList.add('buttonstep')
          this.$refs.mbutton3.classList.add('buttonstep')
          this.$refs.mbutton4.classList.add('buttonstep')
          this.$refs.mbutton5.classList.add('buttonstep')
          this.$refs.mbutton6.classList.add('buttonstep')
          this.$refs.button1collapse.show = false
          this.$refs.button3collapse.show = false
          this.$refs.button4collapse.show = false
          this.$refs.button5collapse.show = false
          this.$refs.button6collapse.show = false
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep')
            this.$refs.mbutton5.classList.remove('buttonstep')
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep')
            this.$refs.mbutton6.classList.remove('buttonstep')
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep')
            this.$refs.mbutton4.classList.remove('buttonstep')
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep')
            this.$refs.mbutton3.classList.remove('buttonstep')
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep')
            this.$refs.mbutton2.classList.remove('buttonstep')
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep')
            this.$refs.mbutton1.classList.remove('buttonstep')
          }
        }
        if (a === 3) {
          this.$refs.button3.classList.remove('buttonstep')
          this.$refs.mbutton3.classList.remove('buttonstep')
          this.$refs.button1.classList.add('buttonstep')
          this.$refs.button2.classList.add('buttonstep')
          this.$refs.button4.classList.add('buttonstep')
          this.$refs.button5.classList.add('buttonstep')
          this.$refs.button6.classList.add('buttonstep')
          this.$refs.mbutton1.classList.add('buttonstep')
          this.$refs.mbutton2.classList.add('buttonstep')
          this.$refs.mbutton4.classList.add('buttonstep')
          this.$refs.mbutton5.classList.add('buttonstep')
          this.$refs.mbutton6.classList.add('buttonstep')
          this.$refs.button1collapse.show = false
          this.$refs.button2collapse.show = false
          this.$refs.button4collapse.show = false
          this.$refs.button5collapse.show = false
          this.$refs.button6collapse.show = false
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep')
            this.$refs.mbutton5.classList.remove('buttonstep')
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep')
            this.$refs.mbutton6.classList.remove('buttonstep')
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep')
            this.$refs.mbutton4.classList.remove('buttonstep')
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep')
            this.$refs.mbutton3.classList.remove('buttonstep')
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep')
            this.$refs.mbutton2.classList.remove('buttonstep')
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep')
            this.$refs.mbutton1.classList.remove('buttonstep')
          }
        }
        if (a === 4) {
          this.$refs.button4.classList.remove('buttonstep')
          this.$refs.mbutton4.classList.remove('buttonstep')
          this.$refs.button1.classList.add('buttonstep')
          this.$refs.button2.classList.add('buttonstep')
          this.$refs.button3.classList.add('buttonstep')
          this.$refs.button5.classList.add('buttonstep')
          this.$refs.button6.classList.add('buttonstep')
          this.$refs.mbutton1.classList.add('buttonstep')
          this.$refs.mbutton2.classList.add('buttonstep')
          this.$refs.mbutton3.classList.add('buttonstep')
          this.$refs.mbutton5.classList.add('buttonstep')
          this.$refs.mbutton6.classList.add('buttonstep')
          this.$refs.button1collapse.show = false
          this.$refs.button2collapse.show = false
          this.$refs.button3collapse.show = false
          this.$refs.button5collapse.show = false
          this.$refs.button6collapse.show = false
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep')
            this.$refs.mbutton5.classList.remove('buttonstep')
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep')
            this.$refs.mbutton6.classList.remove('buttonstep')
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep')
            this.$refs.mbutton4.classList.remove('buttonstep')
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep')
            this.$refs.mbutton3.classList.remove('buttonstep')
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep')
            this.$refs.mbutton2.classList.remove('buttonstep')
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep')
            this.$refs.mbutton1.classList.remove('buttonstep')
          }
        }
        if (a === 5) {
          this.$refs.button5.classList.remove('buttonstep')
          this.$refs.mbutton5.classList.remove('buttonstep')
          this.$refs.button1.classList.add('buttonstep')
          this.$refs.button2.classList.add('buttonstep')
          this.$refs.button3.classList.add('buttonstep')
          this.$refs.button4.classList.add('buttonstep')
          this.$refs.button6.classList.add('buttonstep')
          this.$refs.mbutton1.classList.add('buttonstep')
          this.$refs.mbutton2.classList.add('buttonstep')
          this.$refs.mbutton3.classList.add('buttonstep')
          this.$refs.mbutton4.classList.add('buttonstep')
          this.$refs.mbutton6.classList.add('buttonstep')
          this.$refs.button1collapse.show = false
          this.$refs.button2collapse.show = false
          this.$refs.button3collapse.show = false
          this.$refs.button4collapse.show = false
          this.$refs.button6collapse.show = false
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep')
            this.$refs.mbutton5.classList.remove('buttonstep')
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep')
            this.$refs.mbutton6.classList.remove('buttonstep')
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep')
            this.$refs.mbutton4.classList.remove('buttonstep')
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep')
            this.$refs.mbutton3.classList.remove('buttonstep')
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep')
            this.$refs.mbutton2.classList.remove('buttonstep')
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep')
            this.$refs.mbutton1.classList.remove('buttonstep')
          }
        }
        if (a === 6) {
          this.$refs.button6.classList.remove('buttonstep')
          this.$refs.mbutton6.classList.remove('buttonstep')
          this.$refs.button1.classList.add('buttonstep')
          this.$refs.button2.classList.add('buttonstep')
          this.$refs.button3.classList.add('buttonstep')
          this.$refs.button4.classList.add('buttonstep')
          this.$refs.button5.classList.add('buttonstep')
          this.$refs.mbutton1.classList.add('buttonstep')
          this.$refs.mbutton2.classList.add('buttonstep')
          this.$refs.mbutton3.classList.add('buttonstep')
          this.$refs.mbutton4.classList.add('buttonstep')
          this.$refs.mbutton5.classList.add('buttonstep')
          this.$refs.button1collapse.show = false
          this.$refs.button2collapse.show = false
          this.$refs.button3collapse.show = false
          this.$refs.button4collapse.show = false
          this.$refs.button5collapse.show = false
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep')
            this.$refs.mbutton5.classList.remove('buttonstep')
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep')
            this.$refs.mbutton6.classList.remove('buttonstep')
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep')
            this.$refs.mbutton4.classList.remove('buttonstep')
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep')
            this.$refs.mbutton3.classList.remove('buttonstep')
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep')
            this.$refs.mbutton2.classList.remove('buttonstep')
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep')
            this.$refs.mbutton1.classList.remove('buttonstep')
          }
        }
      }
      if (this.offermakingtype === 'HurtigtTilbud' || this.offermakingtype === 'UploadTilbud') {
        if (a === 2) {
          this.$refs.button2.classList.remove('buttonstep')
          this.$refs.button4.classList.add('buttonstep')
          this.$refs.button4collapse.show = false
          this.$refs.button1collapse.show = false
          this.$refs.button3collapse.show = false
          this.$refs.button5collapse.show = false
          this.$refs.button6collapse.show = false
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep')
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep')
          }
        }
        if (a === 4) {
          this.$refs.button4.classList.remove('buttonstep')
          this.$refs.button2.classList.add('buttonstep')
          this.$refs.button2collapse.show = false
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep')
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep')
          }
        }
      }
    },
    showcustomerselection () {
      document.getElementById('customerstext').classList.remove('hide')
      this.getallactivecustomerandofferbypartner()
    },
    hidecustomerselection () {
      document.getElementById('customersselect').classList.add('hide')
      document.getElementById('customerstext').classList.add('hide')
      document.querySelector('#newcustomers').classList.remove('hide')
      document.querySelector('#newcustomersss').classList.remove('hide')
      this.customers = null
    },
    resetcustomerdata () {
      this.form.navm = null
      this.form.email = null
      this.form.mobile = null
      this.seletectedaddress = ''
    },
    resettaskdata () {
      this.form.offerdescription = null
      this.form.offeramount = null
      this.form.quantity = 1
      this.form.quantityunit = 0
    },
    resettaskrow () {
      this.row = {
        uuid: '',
        name: '',
        selected_item: null,
        show_custom_item: false,
        custom_name: '',
        quantity: 1,
        unitPrice: 0,
        discount: 0,
        tax: 0,
        type: 1,
        amount: 0,
        description: ''
      }
    },
    resettaskrowminbolig () {
      this.rowbolig = {
        title: '',
        description: '',
        unit: '',
        value: '',
        quantity: ''
      }
    },
    resetinfo () {
      this.info = {
        currency_id: null,
        customer_id: null,
        date: this.currentandexpiryDateTime(),
        expiry_date: this.currentandexpiryDateTime('expiry'),
        expiry_date_detail: '',
        uploadToken: '',
        itme_type: '',
        rows: [],
        subject: '',
        description: '',
        subtotal: 0,
        subtotalDiscount: 0,
        line_item_discount_type: true,
        subtotalDiscount_type: false,
        subtotalTax: 25,
        subtotalShippingAndHandling: 0,
        total: 0,
        reference_number: '',
        quotation_prefix: '',
        quotationPrefix: '',
        isDraft: 0,
        show_sub_total_tax: true,
        show_sub_total_discount: true,
        show_sub_total_shipping_and_handling: true,
        show_line_item_tax: true,
        show_line_item_discount: true,
        show_line_item_description: true,
        customer_note: '',
        memo: '',
        tnc: ''
      }
    },
    resetalldataaftersend () {
      this.resetcustomerdata()
      this.resettaskdata()
      this.resettaskrow()
      this.resetinfo()
      if (this.currentstep === 3) {
        document.querySelector('div#thirdstep').classList.remove('activecustomerstep')
        document.querySelector('div#firststep').classList.add('activecustomerstep')
      }
      this.currentstep = 1
      this.editingdraft = 0
      this.rows = []
      this.fordelete = []
      this.customers = []
      this.form.bilagfile = []
      this.form.termsnote = ''
      this.form.termsbetingelser = ''
      this.form.headings = ''
      this.form.headerImage = ''
      this.getallofferbypartner()
      this.updareferencenumber()
    },
    currentandexpiryDateTime (a = null) {
      const current = new Date()
      if (a !== null) {
        current.setDate(current.getDate() + 30)
      }
      const date = current.getFullYear() + '-' + (current.getMonth() + 1) + '-' + current.getDate()
      const time = current.getHours() + ':' + current.getMinutes() + ':' + current.getSeconds()
      const dateTime = date + ' ' + time
      return dateTime
    },
    fordeletecontinue (item) {
      this.fordelete = item
    },
    deletedrafttilbud (item) {
      this.loading = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {
        operation: 'delTilbud',
        salesPerson: this.salesPerson,
        tilbud_id: item.appid,
        offer_id: item.id
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.loading = false
            this.hidemodaldrafteeditordelete()
            this.hideModaldrafts()
            this.getallofferbypartner()
            if (res.success) {
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    deletetask (row) {
      let idx = this.rows.indexOf(row)
      if (idx > -1) {
        this.rows.splice(idx, 1)
      }
      if (this.rows.length === 0) {
        this.subtotalprice = 0
        this.compututedtaxsingle = 0
        this.info.subtotal = 0
        this.info.total = 0
      }
      if (this.rows.length > 0) {
        this.subtotalprice = this.rows.reduce((acc, item) => acc + item.amount, 0)
        this.compututedtaxsingle = (parseInt(this.subtotalprice) + parseInt((this.subtotalprice * (this.info.subtotalTax / 100))))
        if (this.info.subtotalDiscount !== 0) {
          if (this.info.subtotalDiscount_type) {
            this.compututedtaxsingle = (parseInt(this.compututedtaxsingle) - parseInt(this.compututedtaxsingle * (this.form.discount / 100)))
          } else {
            this.compututedtaxsingle = (parseInt(this.compututedtaxsingle) - parseInt(this.form.discount))
          }
        }
        this.info.subtotal = this.subtotalprice
        this.info.total = this.compututedtaxsingle
      }
    },
    deletetaskminbolig (row) {
      this.error.notask = ''
      let idx = this.rows.indexOf(row)
      if (idx > -1) {
        this.rows.splice(idx, 1)
      }
      if (this.rows.length === 0) {
        this.subtotalprice = 0
        this.compututedtaxsingle = 0
        this.info.subtotal = 0
        this.info.total = 0
      }
      if (this.rows.length > 0) {
        this.subtotalprice = this.rows.reduce((acc, item) => acc + item.amount, 0)
        this.compututedtaxsingle = (parseInt(this.subtotalprice) + parseInt((this.subtotalprice * (this.info.subtotalTax / 100))))
        if (this.info.subtotalDiscount !== 0) {
          if (this.info.subtotalDiscount_type) {
            this.compututedtaxsingle = (parseInt(this.compututedtaxsingle) - parseInt(this.compututedtaxsingle * (this.form.discount / 100)))
          } else {
            this.compututedtaxsingle = (parseInt(this.compututedtaxsingle) - parseInt(this.form.discount))
          }
        }
        this.info.subtotal = this.subtotalprice
        this.info.total = this.compututedtaxsingle
      }
      var sumrow = []
      sumrow = this.rowsbolig.filter(function (a) {
        return a.title === row.custom_name && a.value === row.amount
      })
      let idxs = this.rowsbolig.indexOf(sumrow[0])
      if (idxs > -1) {
        this.rowsbolig.splice(idxs, 1)
      }
    },
    disabletheother () {
      if (this.form.discountamount > 0) {
        document.getElementById('discountpercentage').disabled = true
      } else if (this.form.discountamount === '') {
        document.getElementById('discountpercentage').disabled = false
      } else {
        document.getElementById('discountpercentage').disabled = false
      }
      if (this.form.discountpercentage > 0) {
        document.getElementById('discountamount').disabled = true
      } else if (this.form.discountamount === '') {
        document.getElementById('discountamount').disabled = false
      } else {
        document.getElementById('discountamount').disabled = false
      }
    },
    confirmtilbud (a = null) {
      if (a === 'finaloffer') {
        this.addtilbud()
      } else if (a === 'draftfinaloffer') {
        this.addtilbud()
      }
    },
    confirmmanswertilbud (type, answer) {
      if (answer === 'yes') {
        if (this.editingdraft === 0) {
          return dialog => this.addtilbud()
        } else if (this.editingdraft === 1) {
          return dialog => this.addtilbud()
        } else {
          alert('Something went wrong here at saving your tilbud')
        }
      } else if (answer === 'no') {
        if (type === 'final') {
          return dialog => this.addglow()
        } else if (type === 'saveasdraft') {
          return dialog => this.updatetilbud()
        } else {
          alert('Something went wrong here at saving your tilbud 2')
        }
      }
    },
    continueeditdrafttilbud (item) {
      this.editingdraft = 1
      this.error.notask = ''
      this.tilbud = item
      this.info = item.info
      this.loading = true
      this.$refs.drafteeditordeletemodal.hide()
      this.$refs.quickofferdraft.hide()
      if (this.currentstep === 3) {
        document.querySelector('div#thirdstep').classList.remove('activecustomerstep')
        document.querySelector('div#firststep').classList.add('activecustomerstep')
      }
      this.currentstep = 1
      this.usereferencenumber = this.tilbud.info.reference_number
      this.rows = this.tilbud.info.rows
      this.appid = this.tilbud.appid
      this.info.subtotal = parseFloat(this.tilbud.info.subtotal)
      this.info.total = parseFloat(this.tilbud.info.total)
      this.info.subtotalDiscount = parseFloat(this.tilbud.info.subtotalDiscount)
      this.info.subtotalDiscount_type = this.tilbud.info.subtotalDiscount_type
      if (this.info.subtotalDiscount > 0) {
        if (this.info.subtotalDiscount_type) {
          this.form.discount = parseFloat(this.form.discountpercentage)
          this.form.discountsymbol = '%'
          this.form.discountpercentage = parseFloat(this.tilbud.info.subtotalDiscount)
          this.compututedtaxsingle = (parseFloat(this.compututedtaxsingle) - parseFloat(this.compututedtaxsingle * (this.form.discount / 100)))
        } else {
          this.form.discount = parseFloat(this.tilbud.info.subtotalDiscount)
          this.form.discountsymbol = 'kr'
          this.form.discountamount = parseFloat(this.tilbud.info.subtotalDiscount)
          this.compututedtaxsingle = (parseFloat(this.compututedtaxsingle) - parseFloat(this.form.discount))
        }
      }
      this.subtotalprice = this.rows.reduce((acc, item) => acc + item.amount, 0)
      this.compututedtaxsingle = (parseFloat(this.subtotalprice) + parseFloat((this.subtotalprice * (this.info.subtotalTax / 100))))
      this.info.subtotal = parseFloat(this.subtotalprice)
      this.info.total = parseFloat(this.compututedtaxsingle)
      this.form.bilagfile = this.tilbud.bilagfile
      this.fiverecommendations = JSON.parse(this.tilbud.recommendations)
      this.getallactivecustomerandofferbypartner(this.tilbud.appid)
      this.form.headings = this.tilbud.header_text
      this.form.termsnote = this.tilbud.notat
      this.header_image = this.tilbud.header_image
      this.header_image = this.header_image.replaceAll('håndværker', 'haandvaerker')
      this.form.termsbetingelser = this.tilbud.betingelser
    },
    getallactivecustomerandofferbypartner (customerid = null) {
      /* this is use to get the list of already added customers by user */
      this.loading = true
      var cid = this.$route.query.id
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '1', cid: cid}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res.array
            var customerx = []
            this.loading = false
            if (customerid !== null) {
              customerx = this.items.filter((item) => {
                return item.id_appointment === customerid
              })
              this.customers = customerx[0]
              if (this.customers !== undefined) {
                this.assigncustomerinput(this.customers)
              }
              this.seletectedaddress = ''
              this.seletectedaddress = this.customers.mailingstreet + ', ' + this.customers.mailingzip + ' ' + this.customers.mailingcity
            }
            if (this.kunderid !== '' && typeof this.kunderid !== 'undefined') {
              this.getcustomerdetailsfromminekunder(this.kunderid)
            }
            if (this.$route.query.name) {
              setTimeout(() => {
                this.checkCustomer()
              }, 100)
            }
          },
          response => {
            alert('error getting you customers')
          })
    },
    getallofferbypartner () {
      var draftimesrow = []
      var draftfilteredrow = []
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'userTilbuds', salesPerson: this.salesPerson}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.alltilbudanduserinfo = res
            this.usereferencenumber = 'REF' + parseInt(this.alltilbudanduserinfo.totaloffer + 1) + '-' + this.alltilbudanduserinfo.partnerid
            this.alltilbud = res.tilbud
            /* this is to get all drafts */
            draftfilteredrow = this.alltilbud.filter((item) => {
              return item.is_darft > 0
            })
            draftfilteredrow.forEach(function (offer, index) {
              draftimesrow.push(offer)
            })
            this.draftitems = draftimesrow
            /* end of this is to get all drafts */
            this.loading = false
          },
          response => {
            alert('error')
          })
    },
    getcustomerdetailsfromminekunder (custimerid) {
      var custdetails = []
      custdetails = this.items.filter(a => {
        return a.contactid === custimerid
      })
      setTimeout(() => {
        this.assigncustomerinput(custdetails[0])
        this.customers = custdetails[0].firstname + ' ' + custdetails[0].lastname + ', ' + custdetails[0].email + '-' + custdetails[0].mobile
        var addr = ''
        addr = custdetails[0].mailingstreet + ', ' + custdetails[0].mailingzip + ' ' + custdetails[0].mailingcity
        this.seletectedaddress = addr
        this.assignaddresseinput(addr)
      }, 100)
    },
    getaddressfromkeyword (keyword) {
      var inputkey = keyword
      var searchgaddresses = []
      this.addressloading = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'findAddress', salesPerson: this.salesPerson, keyword: inputkey}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.addresses = res
            this.addresses.forEach(function (address, index) {
              searchgaddresses.push(address.tekst)
            })
            // })
            // this.addresses.forEach(function (address, index) {
            //   searchgaddresses.push(address.adresse.adresseringsvejnavn + ' ' + address.adresse.husnr + ', ' + address.adresse.postnr + ' ' + address.adresse.postnrnavn)
            // })
            this.searchgaddress = searchgaddresses
            this.addressloading = false
            this.focusthis()
          },
          response => {
            alert('error')
          })
    },
    getterms (type = null, id = null, c = null) {
      var data = {operation: 'terms', salesPerson: this.salesPerson}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.terms = res
            this.termsbetingelser = this.terms.filter((termsitem) => {
              return termsitem.type === 'betingelser'
            })
            this.termsnotes = this.terms.filter((termsbet) => {
              return termsbet.type === 'note'
            })
            if (c !== null && type === 'note') {
              this.assigntermsinput(type, this.termsnotes[0])
            } else if (c !== null && type !== 'note') {
              this.assigntermsinput(type, this.termsbetingelser[0])
            }
            if (id !== null) {
              if (type === 'note') {
                this.termsnotats = this.termsnotes.filter((itemss) => {
                  return itemss.id === id
                })
                this.termsnotats = 'Ingen bemærkninger'
              } else {
                this.termsbetings = this.termsbetingelser.filter((itemss) => {
                  return itemss.id === id
                })
              }
            } else {
              // this.termsnotats = this.termsnotes[0]
              // this.termsnotats['description'] = 'Ingen bemærkninger'
              this.termsnotats['description'] = ''
              this.assigntermsinput('note', this.termsnotats)
              // this.termsbetings = this.termsbetingelser[0]
              // this.termsbetings['description'] = 'Ingen bemærkninger'
              this.termsbetings['description'] = ''
              this.assigntermsinput('betingelser', this.termsbetings)
            }
          },
          response => {
            alert('error')
          })
    },
    getallrecommendations () {
      this.loading = true
      var data = {operation: 'anbefalinger', salesPerson: this.salesPerson, levid: this.haaid}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.allrecommendatationsitems = res
            var toprecords = []
            var topfiverecords = []
            toprecords = this.allrecommendatationsitems.filter((item) => {
              return item.Rating > 3.9
            })
            toprecords.sort(function (a, b) { return a - b })
            topfiverecords = toprecords.slice(0, 5)
            // topfiverecords.forEach(function (item, index) {
            //   this.assignfiverecommendations(item)
            // })
            this.fiverecommendations = topfiverecords.map((item, index) => {
              return item.ReviewId
            })
            this.loading = false
          },
          response => {
            alert('error')
          })
    },
    getallheaderimage () {
      this.loading = true
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaid}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.alliheadermages = res.resultImages
            this.header_image = this.alliheadermages[0].FileLocation
            this.header_image = this.header_image.replaceAll('håndværker', 'haandvaerker')
            this.loading = false
          },
          response => {
            alert('error')
          })
    },
    removethisrecommendation (item) {
      let idx = this.fiverecommendations.indexOf(item)
      if (idx > -1) {
        this.fiverecommendations.splice(idx, 1)
      }
      document.querySelector('div#box' + item).classList.remove('reviewbox')
    },
    removethisactiveheader (item) {
      document.getElementById(item).classList.remove('mainimageheader')
    },
    removeitembilag (item) {
      this.form.bilagfile.splice(this.form.bilagfile.indexOf(item), 1)
    },
    checkifselected (item) {
      if (this.fiverecommendations.includes(item)) {
        return true
      } else {
        return false
      }
    },
    checkthebox (item) {
      if (this.fiverecommendations.includes(item)) {
        if (document.querySelector('div#box' + item) !== null) {
          var el = document.querySelector('div#box' + item)
          el.classList.add('reviewbox')
        }
      } else {
        return ''
      }
    },
    checkifthisisheaderimageactive (item) {
      if (item.replaceAll('håndværker', 'haandvaerker') === this.header_image.replaceAll('håndværker', 'haandvaerker')) {
        document.getElementById(item.replaceAll('håndværker', 'haandvaerker')).classList.add('mainimageheader')
      }
    },
    assignthisheaderimage (item) {
      this.removethisactiveheader(this.header_image.replaceAll('håndværker', 'haandvaerker'))
      this.header_image = item.replaceAll('håndværker', 'haandvaerker')
      this.checkifthisisheaderimageactive(item)
    },
    assignfiverecommendations (item) {
      this.fiverecommendations.push(item)
      if (this.checkifselected(item)) {
        document.querySelector('div#box' + item).classList.add('reviewbox')
      }
      if (this.fiverecommendations.length === 5) {
        // document.querySelectorAll('#addthisreview').classlist.add('no-events')
        // document.querySelector('button#addthisreview' + item).disabled = true
      }
    },
    assigntermsinput (type, item) {
      if (type === 'note') {
        // this.getterms(type, item.id)
        this.termsnotats = item
        this.form.termsnote = item.description
      } else {
        this.termsbetings = item
        this.form.termsbetingelser = item.description
      }
    },
    assigncustomerinput (item) {
      // this.updareferencenumber(item.partner_id)
      if (item !== null && typeof item !== 'undefined') {
        this.form.navm = item.firstname + ' ' + item.lastname
        this.form.email = item.email
        this.form.mobile = item.mobile
        this.appid = item.id_appointment
        this.form.adresse = item.mailingstreet + ' ' + item.mailingzip + ' ' + item.mailingcity
        this.seletectedaddress = this.form.adresse
        this.error.notask = ''
        this.customerInputDisabled = true
      } else {
        this.form.navm = ''
        this.form.email = ''
        this.form.mobile = ''
      }
    },
    assigndatecomment () {
      this.info.date = this.form.dateoffer
      this.info.expiry_date = this.form.dateofferexpiry
      this.info.customer_note = this.form.comment
    },
    assignaddresseinput (item) {
      this.form.adresse = item
      // this.form.adresseadgang = item[2]
      // this.form.adresse = item[0]
    },
    computetaskprice () {
      /* compute the price from the input fields with the default value in data return */
      var subtotalprice = (parseInt(this.form.offeramount * this.form.quantity) + parseInt(((this.form.offeramount * this.form.quantity) * (this.info.subtotalTax / 100))))
      this.subtotalprices = subtotalprice
      return subtotalprice
    },
    localeParseFloat (s, locale) {
    // // Get the thousands and decimal separator characters used in the locale.
    // let [,thousandsSeparator,,,,decimalSeparator] = 1111.1.toLocaleString(locale)
    // // Remove thousand separators, and put a point where the decimal separator occurs
    // s = Array.from(s, c => c === thousandsSeparator ? '' : c === decimalSeparator ? '' . '' : c).join('')
    // // Now it can be parsed
    // return parseFloat (s);
    },
    addtask () {
      var unitofaty = ''
      if ((this.form.offeramount === null || this.form.offerdescription === null || this.form.quantity === null) && this.offermakingtype !== 'UploadTilbud') {
        this.error.notask = 'Udfyld opgavebeskrivelsen og prisen'
        return false
      } else {
        /* add task inside info.row from the inputs of step 1 */
        this.row.unitPrice = parseFloat(this.form.offeramount)
        this.row.quantity = parseFloat(this.form.quantity)
        if (this.form.quantityunit === null || this.form.quantityunit === 0) {
          this.form.quantityunit = 0
          unitofaty = 'Antal'
          this.row.amount = parseFloat(this.form.offeramount * this.form.quantity)
        } else if (this.form.quantityunit === 1) {
          unitofaty = 'Beløb'
          this.row.amount = parseFloat(this.form.offeramount)
        } else {
          unitofaty = 'Timer'
          this.row.amount = parseFloat(this.form.offeramount * this.form.quantity)
        }
        this.rowbolig.title = this.form.offerdescription
        this.rowbolig.description = this.form.offerdescription
        this.rowbolig.unit = unitofaty
        this.rowbolig.value = parseFloat(this.form.offeramount * this.form.quantity)
        this.rowbolig.quantity = parseFloat(this.form.quantity)
        this.row.type = parseFloat(this.form.quantityunit)
        this.row.custom_name = this.form.offerdescription
        this.row.uuid = uuid()
        this.rowsbolig.push(this.rowbolig)
        this.rows.push(this.row)
        this.subtotalprice = this.rows.reduce((acc, item) => acc + item.amount, 0)
        this.compututedtaxsingle = (parseFloat(this.subtotalprice) + parseFloat((this.subtotalprice * (this.info.subtotalTax / 100))))
        this.info.subtotal = parseFloat(this.subtotalprice)
        this.info.total = parseFloat(this.compututedtaxsingle)
        // this.resettaskdata()
        this.resettaskrow()
        this.resettaskrowminbolig()
        this.error.notask = ''
        this.form.offeramount = null
        this.form.quantity = 1
        this.form.offerdescription = null
      }
    },
    addiscount () {
      /*  percent  true    amount false */
      if (this.form.discountamount > 0) {
        this.info.subtotalDiscount = parseFloat(this.form.discountamount)
        this.info.subtotalDiscount_type = false
      }
      if (this.form.discountpercentage > 0) {
        this.info.subtotalDiscount = parseFloat(this.form.discountpercentage)
        this.info.subtotalDiscount_type = true
      }
      if (this.info.subtotalDiscount !== 0) {
        if (this.info.subtotalDiscount_type) {
          this.form.discount = parseFloat(this.form.discountpercentage)
          this.form.discountsymbol = '%'
          this.compututedtaxsingle = (parseFloat(this.compututedtaxsingle) - parseFloat(this.compututedtaxsingle * (this.form.discount / 100)))
        } else {
          this.form.discount = parseFloat(this.form.discountamount)
          this.form.discountsymbol = 'kr'
          this.compututedtaxsingle = (parseFloat(this.compututedtaxsingle) - parseFloat(this.form.discount))
        }
      }
      this.info.subtotal = parseFloat(this.subtotalprice)
      this.info.total = parseFloat(this.compututedtaxsingle)
    },
    addCustomer () {
      if (this.form.navm === null || this.form.email === null || this.form.mobile === null) {
        this.error.notask = 'Noget mangler i dine kundeoplysninger. Kontroller venligst'
        return false
      } else if (this.customers !== null) {
        this.appid = this.appid
      } else {
        var data = {
          operation: 'addUserPartner',
          salesPerson: this.salesPerson,
          name: this.form.navm,
          email: this.form.email,
          mobile: this.form.mobile,
          address: this.form.adresse,
          addressid: this.form.adresseid,
          adgangsadresseid: this.form.adresseadgang
        }
        this.$http.post('', data, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              if (res.success) {
                var addcus = res
                this.appid = addcus.appid
                this.getallactivecustomerandofferbypartner(this.appid)
                document.getElementById('customers').classList.remove('hide')
                document.getElementById('newcustomers').classList.add('hide')
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
              } else {
                alert('sorry something went wrong in adding your customer')
              }
            },
            response => {
              alert('error in adding customer')
            }
          )
      }
    },
    addtilbud () {
      var asktext = ''
      var confirfinaltext = ''
      var cancelfinaltext = ''
      if (this.editingdraft === 0) {
        asktext = 'Har du set forhåndsvisningen?'
        confirfinaltext = 'Send tilbud til kundens email'
        cancelfinaltext = 'Annuller'
      } else {
        asktext = 'vil du ikke lave dette som et sidste tilbud eller gemme stadig som et udkast?'
        confirfinaltext = 'Indsend'
        cancelfinaltext = 'Opdater kladde'
      }
      this.$confirm(asktext, {
        confirmButtonText: confirfinaltext,
        cancelButtonText: cancelfinaltext,
        type: 'warning'
      }).then(() => {
        /* add the final datas to tilbud */
        if (this.offermakingtype === 'UploadTilbud') {
          this.addtask()
        }
        if (this.validator()) {
          return false
        } else {
          if (this.$route.query.projectId) {
            this.addOffer()
          } else {
            if (this.customers === null) {
              if (this.form.navm === null || this.form.email === null || this.form.mobile === null) {
                this.error.notask = 'Noget mangler i dine kundeoplysninger. Kontroller venligst'
                return false
              } else if (this.customers !== null) {
                this.appid = this.appid
              } else {
                this.mainloading = true
                this.previewloading = true
                var datas = {
                  operation: 'addUserPartner',
                  salesPerson: this.salesPerson,
                  name: this.form.navm,
                  email: this.form.email,
                  mobile: this.form.mobile,
                  address: this.form.adresse,
                  addressid: this.form.adresseid,
                  adgangsadresseid: this.form.adresseadgang
                }
                this.$http.post('', datas, { emulateJSON: true })
                  .then(
                    response => {
                      var res = response.body
                      if (res.success) {
                        var addcus = res
                        this.appid = addcus.appid
                        this.getallactivecustomerandofferbypartner(this.appid)
                        this.info.rows = this.rows
                        this.info.reference_number = this.usereferencenumber
                        var data = {
                          operation: 'addTilbud',
                          salesPerson: this.salesPerson,
                          levid: this.haaid,
                          tilbud_id: this.appid,
                          betingelser: this.form.termsbetingelser,
                          bilag: this.form.bilagfile.toString().replaceAll('[', ' ').replaceAll(']', ' '),
                          is_darft: 0,
                          offerfile: this.uploadedpdf,
                          onlyfile: this.onlyfile,
                          notat: this.form.termsnote,
                          header_text: this.form.headings,
                          header_image: this.header_image,
                          recommendations: JSON.stringify(this.fiverecommendations),
                          tilbud: JSON.stringify(this.info),
                          bilagfile: JSON.stringify(this.form.bilagfile),
                          files: JSON.stringify(this.tilbud.files),
                          image: this.tilbud.image,
                          reference_number: this.usereferencenumber
                        }
                        this.$http.post('', data, { emulateJSON: true })
                          .then(
                            response => {
                              var res = response.body
                              if (res.success) {
                                this.previewloading = false
                                this.mainloading = false
                                let obj = {
                                  title: 'Gennemført!',
                                  message: '',
                                  type: 'success',
                                  customCloseBtnText: 'Luk'
                                }
                                this.$refs.simplert.openSimplert(obj)
                                // if (this.editingdraft === 1) {
                                //   this.deletedrafttilbud(this.fordelete)
                                // }
                                this.resetalldataaftersend()
                                setTimeout(() => {
                                  this.gotohistory()
                                }, 2000)
                              } else {
                                alert('error add tilbud')
                              }
                            },
                            response => {
                              alert('error adding tilbuds')
                            }
                          )
                      } else {
                        alert('sorry something went wrong in adding your customer')
                      }
                    },
                    response => {
                      alert('error in adding customer')
                    }
                  )
              }
            } else {
              this.mainloading = true
              this.previewloading = true
              this.info.rows = this.rows
              this.info.reference_number = this.usereferencenumber
              var data = {
                operation: 'addTilbud',
                salesPerson: this.salesPerson,
                levid: this.haaid,
                tilbud_id: this.appid,
                betingelser: this.form.termsbetingelser,
                bilag: this.form.bilagfile.toString().replaceAll('[', ' ').replaceAll(']', ' '),
                is_darft: 0,
                offerfile: this.uploadedpdf,
                onlyfile: this.onlyfile,
                notat: this.form.termsnote,
                header_text: this.form.headings,
                header_image: this.header_image,
                recommendations: JSON.stringify(this.fiverecommendations),
                tilbud: JSON.stringify(this.info),
                bilagfile: JSON.stringify(this.form.bilagfile),
                files: JSON.stringify(this.tilbud.files),
                image: this.tilbud.image,
                reference_number: this.usereferencenumber
              }
              this.$http.post('', data, { emulateJSON: true })
                .then(
                  response => {
                    var res = response.body
                    if (res.success) {
                      this.previewloading = false
                      this.mainloading = false
                      let obj = {
                        title: 'Gennemført!',
                        message: '',
                        type: 'success',
                        customCloseBtnText: 'Luk'
                      }
                      this.$refs.simplert.openSimplert(obj)
                      // if (this.editingdraft === 1) {
                      //   this.deletedrafttilbud(this.fordelete)
                      // }
                      this.resetalldataaftersend()
                      setTimeout(() => {
                        this.gotohistory()
                      }, 2000)
                    } else {
                      alert('error add tilbud')
                    }
                  },
                  response => {
                    alert('error adding tilbuds')
                  }
                )
            }
          }
        }
      }).catch(() => {
        if (this.editingdraft === 0) {
          this.addglow()
        } else if (this.editingdraft === 1) {
          this.updatetilbud()
        }
      })
    },
    addOffer () {
      var vatamount = parseFloat(0.25 * this.subtotalprice)
      var projId = this.$route.query.projectId
      this.loading = true
      // this.previewloading = true
      this.info.rows = this.rows
      this.info.reference_number = this.usereferencenumber
      this.salesPersonNew = localStorage.getItem('id_token_portalbitrix')
      var formDescription = this.rowsbolig[0].description
      if (this.offermakingtype === 'HurtigtTilbud') {
        this.form.headings = this.rowsbolig[0].description
      }
      if (this.offermakingtype === 'UploadTilbud') {
        this.form.headings = 'Uploadet Tilbud'
        formDescription = formDescription !== null ? this.rowsbolig[0].description : 'Uploadet Tilbud'
      }
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonNew
      }
      var data = {
        projectId: projId,
        offers: [{
          title: this.form.headings,
          description: formDescription,
          subtotalPrice: this.subtotalprice,
          vat: vatamount,
          totalPrice: parseFloat(vatamount + this.subtotalprice),
          // startDate: "2022-07-30",
          // endDate: "2022-07-30",
          // expiryDate: "2022-07-30",
          // fileName: "filename.pdf",
          // file: "...base64string...",
          tasks: this.rowsbolig
        }]
      }
      this.$http.post(process.env.BITRIXAPI + 'partner/offer', data, { headers }, { emulateJSON: true }).then(
        response => {
          this.previewloading = false
          this.loading = false
          let obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          this.resetalldataaftersend()
          setTimeout(() => {
            this.$router.push('/alle-moeder')
          }, 2000)
        },
        response => {
          this.loading = false
          this.formLoading = false
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    },
    addterms (type) {
      var title = ''
      var desc = ''
      var typeterm = ''
      if (type === 'note') {
        title = this.form.termsaddnotetitle
        desc = this.form.termsaddnotedesc
        typeterm = type
      } else {
        title = this.form.termsbetingelsertitle
        desc = this.form.termsbetingelserdesc
        typeterm = type
      }
      this.loading = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {
        operation: 'addTerm',
        salesPerson: this.salesPerson,
        title: title,
        description: desc,
        type: typeterm
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.getterms(type, null, 1)
            if (type === 'note') {
              this.form.termsnote = desc
              this.hideModaladdbrugerdefinerede()
            } else {
              this.form.termsbetingelser = desc
              this.hideModaladdbetingelser()
            }
            if (this.offermakingtype !== 'StandardTilbud') {
              this.hideModalconditions()
            }
            this.loading = false
            let obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
          },
          response => {
            alert('error')
          })
    },
    addglow () {
      document.querySelector('button#preview').classList.add('button-glow')
    },
    addglowenhed () {
      setTimeout(() => {
        document.querySelector('button#enhed').classList.add('button-glow')
      }, 50)
    },
    addglowcustomer () {
      setTimeout(() => {
        document.querySelector('button#selectaddr').classList.add('button-glow')
      }, 50)
    },
    updatetilbud () {
      this.mainloading = true
      this.previewloading = true
      this.info.subtotal = this.subtotalprice
      this.info.total = this.compututedtaxsingle
      this.info.rows = this.rows
      var data = {
        operation: 'editTilbud',
        salesPerson: this.salesPerson,
        tilbud_id: this.appid,
        betingelser: this.form.termsbetingelser,
        bilag: this.tilbud.bilag,
        is_darft: this.tilbud.is_darft,
        notat: this.form.termsnote,
        header_text: this.form.headings,
        header_image: this.header_image,
        recommendations: JSON.stringify(this.fiverecommendations),
        tilbud: JSON.stringify(this.info),
        bilagfile: JSON.stringify(this.form.bilagfile),
        file: this.tilbud.files,
        image: this.tilbud.image,
        reference_number: this.usereferencenumber
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              this.previewloading = false
              this.mainloading = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              setTimeout(() => {
                this.gotohistory()
              }, 2000)
            } else {
              alert('error updating tilbud')
            }
          },
          response => {
            alert('error updating tilbud')
          }
        )
    },
    updareferencenumber (a = null) {
      if (this.editingdraft === 0) {
        this.usereferencenumber = 'REF' + parseInt(this.alltilbudanduserinfo.totaloffer + 1) + '-' + this.alltilbudanduserinfo.partnerid
      }
      if (this.editingdraft === 1) {
        this.usereferencenumber = a
      }
    },
    saveasdraft () {
      this.mainloading = true
      this.info.rows = this.rows
      this.loading = true
      this.info.subtotal = parseFloat(this.subtotalprice)
      this.info.total = parseFloat(this.compututedtaxsingle)
      this.info.reference_number = this.usereferencenumber
      var data = {
        operation: 'addTilbud',
        levid: this.haaid,
        salesPerson: this.salesPerson,
        tilbud_id: this.appid,
        betingelser: this.form.termsbetingelser,
        bilag: this.form.bilagfile.toString().replaceAll('[', ' ').replaceAll(']', ' '),
        is_darft: 1,
        notat: this.form.termsnote,
        header_text: this.form.headings,
        header_image: this.header_image,
        recommendations: JSON.stringify(this.fiverecommendations),
        tilbud: JSON.stringify(this.info),
        bilagfile: JSON.stringify(this.form.bilagfile),
        files: JSON.stringify(this.tilbud.files),
        image: this.tilbud.image,
        reference_number: this.usereferencenumber
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              this.previewloading = false
              this.mainloading = false
              this.resetalldataaftersend()
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              setTimeout(() => {
                this.gotohistory()
              }, 2000)
            } else {
              alert('error saving as draft')
            }
          },
          response => {
            alert('error error saving as draft')
          }
        )
    },
    previewoffer () {
      if (this.offermakingtype === 'UploadTilbud') {
        this.addtask()
      }
      if (this.validator()) {
        return false
      } else {
        this.previewloading = true
        this.info.rows = this.rows
        this.info.reference_number = this.usereferencenumber
        var data = {
          operation: 'preTilbud',
          salesPerson: this.salesPerson,
          offer_id: this.appid,
          tilbud_id: this.appid,
          levid: this.haaid,
          reference_number: this.usereferencenumber,
          notat: this.form.termsnote,
          betingelser: this.form.termsbetingelser,
          bilag: this.form.bilagfile.toString().replaceAll('[', ' ').replaceAll(']', ' '),
          header_text: this.form.headings,
          header_image: this.header_image,
          recommendations: JSON.stringify(this.fiverecommendations),
          tilbud: JSON.stringify(this.info),
          bilagfile: this.form.bilagfile,
          files: this.tilbud.files,
          image: this.tilbud.image
        }
        this.$http.post('', data, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              if (res.success) {
                this.pdfurl = res.pdf
                // this.pdfpdf = res.pdf
                window.open(this.pdfurl, '_blank')
                this.previewloading = false
              } else {
                alert('error previewing')
              }
            },
            response => {
              alert('error previewing')
            }
          )
      }
    },
    gotohistory () {
      this.$router.push('/tilbud/tilbud-historie')
    },
    download_file (fileURL, fileName) {
      // for non-IE
      if (!window.ActiveXObject) {
        var save = document.createElement('a')
        save.href = fileURL
        save.target = '_blank'
        var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1)
        save.download = fileName || filename
        if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search('Chrome') < 0) {
          document.location = save.href
        // window event not working here
        } else {
          var evt = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': false
          })
          save.dispatchEvent(evt)(window.URL || window.webkitURL).revokeObjectURL(save.href)
        }
      } else if (!!window.ActiveXObject && document.execCommand) {
        // for IE < 11
        var _window = window.open(fileURL, '_blank')
        _window.document.close()
        _window.document.execCommand('SaveAs', true, fileName || fileURL)
        _window.close()
      }
    },
    handleFileUploadpdf (file) {
      this.uploadedpdf = file[0]
      // console.log('sdsd', this.uploadedpdf)
      this.itsok = false
      this.onlyfile = true
      this.error.notask = ''
    },
    handleFileUpload (file) {
      var uploadedfiles = []
      this.mainfiles = file
      var newfiles = this.form.bilagfile
      this.form.bilagfile = []
      uploadedfiles = file
      if (uploadedfiles.length > 0) {
        uploadedfiles.forEach(function (item) {
          if (newfiles.includes(item)) {
            // this.form.bilagfile = newfiles
          } else {
            newfiles.push(item)
          }
        })
        this.form.bilagfile = newfiles
        uploadedfiles = []
        newfiles = []
      } else {
        this.form.bilagfile = uploadedfiles
      }
      this.onlyfile = false
      // setTimeout(() => {
      //   document.querySelector('ul.upload-file-list').style.display = 'none'
      // }, 600)
    },
    showbilag () {
      if (this.form.bilagfile.length > 0) {
        setTimeout(() => {
          document.getElementById('bilagfiles').classList.remove('hide')
          document.getElementById('bilagfilestext').classList.remove('hide')
        }, 100)
      }
    },
    offerMenu () {
      // document.getElementById('offerMenu').getElementsByTagName('span')[0].classList.toggle('i_open')
      // document.getElementById('offerMenu').getElementsByTagName('span')[1].classList.toggle('i_close')
      // document.getElementById('PopUp').classList.toggle('show')
    },
    // this is to iterate thrue all form input for validation if null
    validator () {
      if (this.offermakingtype === 'UploadTilbud') {
        if (this.subtotalprice === '' || this.subtotalprice === null || this.subtotalprice === 0) {
          this.error.notask = 'Angiv venligst din pris'
          return true
        }
        if (this.uploadedpdf === '') {
          this.error.notask = 'Upload venligst din pdf'
          return true
        }
      } else {
        if (this.form.navm === null || this.form.email == null || this.form.mobile === null || this.form.adresse === null) {
          this.$refs.button4collapse.show = true
          this.activebutton(4)
          this.error.notask = 'Udfyld venligst dine kunders oplysninger'
          return true
        }
        if (this.form.headings === null) {
          this.$refs.button1collapse.show = true
          this.activebutton(1)
          this.error.notask = 'Udfyld venligst din overskriftstekst for dit tilbud'
          return true
        }
        if (this.rows.length === 0) {
          this.$refs.button2collapse.show = true
          this.activebutton(2)
          this.addglowenhed()
          this.error.notask = 'Tilføj din opgave med den tilsvarende pris'
          return true
        }
      }
    },
    hidenamevalidator () {
      if (this.form.headings !== null) {
        this.error.notask = ''
      }
    },
    getSelectedProj () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonNew
      }
      var data = {}
      var projId = this.$route.query.projectId
      this.$http.get(process.env.BITRIXAPI + 'partner/projects', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          if (res !== null && res.length > 0) {
            for (var i = 0; i < res.length; i++) {
              if (res[i].ID === projId) {
                this.selectedProjectData = res[i]
              }
            }
          }
        },
        response => {
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    }
  }
}
</script>
<style>
#alloffer .dg-main-content {
max-width: 500px!important;
}
#specialrow {
  height:62px;
}
@media (max-width:27em){
  #alloffer .mobile-flex-column {
    flex-direction: column!important;
    align-items: center;
  }
  #alloffer .sm-col-12 {
    width:100%;
  }
  #alloffer .sm-hide {
    display: none;
  }
  #alloffer .mpl0 {
    margin-left: 0;
  }
  #specialrow {
    height: 250px;
  }
}
#datepickeroffer {
  border: 0px;
  width: 100%;
}
#datepickeroffer2 {
  border: 0px;
  width: 100%;
}
#datepickeroffer .vdp-datepicker * {
    width: 100%;
    display: block;
    width: 100%;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    line-height: 1.25;
    color: #3e515b;
    background-color: #fff;
    background-image: none;
    background-clip: padding-box;
    border: 0px solid #d1d4d7;
    border-radius: 0;
}

#alloffer .vdp-datepicker {
    position: relative;
    text-align: left;
    border: 1px solid #d1d4d7;
}
#alloffer .simplert__title {
  white-space:pre-wrap;
}
#alloffer .buttonstep {
  background-color: #19a3c0;
  opacity: 0.5;
  color: white;
  border: 1px solid #19a3c0;
}
#alloffer .offer-form-white-button {
    background-color: #fff;
    border: 1px solid #19a3c0 !important;
}
#alloffer .lightblue-button {
    color: #fff;
    background-color: #19a3c0;
    border: 0;
}
#alloffer .greenblue-button {
    color: #fff;
    background-color: rgba(77, 207, 85, 1.0);
    border: 0;
    width: max(16.66667%,155px,10%);
}
#alloffer .dark-button {
    border: 0px solid #fff;
    height: max(51px,3.2rem);
}
#alloffer .addbuttonresponsive  {
  width: max(16.66667%,155px,10%)
}
#alloffer .mrpointtwo {
  margin-left: .2rem;
}
#headertextimage {
  width: 100%;
}
#alloffer .reviewsoffer {
    height: min(90%, 80vh, 80%);
    width: max(12em,14rem,21em);
}
#alloffer .reviewbox {
  border-style: double;
  border-width: 8px;
  border-color:#12ef12;
}
#alloffer .headerimage {
    height: 12em;
    width: 18em;
}
#alloffer .headerimage:hover {
  border-style: dashed;
  border-color: #003645;
}
#alloffer .mainimageheader {
  border-style: double;
  border-width: 8px;
  border-color:#12ef12;
}
#alloffer .modal-header,
.modal-footer,
.modal-content {
  border-top: 0;
  border-bottom: 0;
}
#alloffer .modal-content {
    background-color: white;
}
#alloffer .lineshade{
  transition: background-color .8s ease-in-out
}
#alloffer .stephead{
  height: 10px;
  background-color:#f5f6f7;
}
#alloffer .activecustomerstep{
  background:  #003645;
}
/*  hover spcial effect*/
#alloffer .containerdrafts :hover {
  background-color: #003645;
  color: white;
  cursor: pointer;
}
#alloffer a div:hover {
    color: white;
    text-decoration: none;
}
#icon_curriculum {
  color: #003645;
}
#deletedraft .dark-button:hover {
  background-color: red;
  color:white;
}
#alloffer .button-glow {
  animation: glowing 2000ms infinite;
}
/* loading icon  */
#alloffer .loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
#alloffer .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#alloffer .loader:before,
#alloffer .loader:after {
  position: absolute;
  content: '';
}
#alloffer .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#alloffer .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
#tilbudoffer {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    -webkit-transition: opacity .6s ease-out;
    transition: opacity .6s ease-out;
    -webkit-animation: socialRotateBack .4s;
    animation: socialRotateBack .4s;
    opacity: 0;
    overflow: hidden;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// standardTilbud.vue?c94012de